let wasm;

const cachedTextDecoder = (typeof TextDecoder !== 'undefined' ? new TextDecoder('utf-8', { ignoreBOM: true, fatal: true }) : { decode: () => { throw Error('TextDecoder not available') } } );

if (typeof TextDecoder !== 'undefined') { cachedTextDecoder.decode(); };

let cachedUint8Memory0 = null;

function getUint8Memory0() {
    if (cachedUint8Memory0 === null || cachedUint8Memory0.byteLength === 0) {
        cachedUint8Memory0 = new Uint8Array(wasm.memory.buffer);
    }
    return cachedUint8Memory0;
}

function getStringFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return cachedTextDecoder.decode(getUint8Memory0().subarray(ptr, ptr + len));
}

const heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

let heap_next = heap.length;

function addHeapObject(obj) {
    if (heap_next === heap.length) heap.push(heap.length + 1);
    const idx = heap_next;
    heap_next = heap[idx];

    heap[idx] = obj;
    return idx;
}

function getObject(idx) { return heap[idx]; }

let WASM_VECTOR_LEN = 0;

const cachedTextEncoder = (typeof TextEncoder !== 'undefined' ? new TextEncoder('utf-8') : { encode: () => { throw Error('TextEncoder not available') } } );

const encodeString = (typeof cachedTextEncoder.encodeInto === 'function'
    ? function (arg, view) {
    return cachedTextEncoder.encodeInto(arg, view);
}
    : function (arg, view) {
    const buf = cachedTextEncoder.encode(arg);
    view.set(buf);
    return {
        read: arg.length,
        written: buf.length
    };
});

function passStringToWasm0(arg, malloc, realloc) {

    if (realloc === undefined) {
        const buf = cachedTextEncoder.encode(arg);
        const ptr = malloc(buf.length, 1) >>> 0;
        getUint8Memory0().subarray(ptr, ptr + buf.length).set(buf);
        WASM_VECTOR_LEN = buf.length;
        return ptr;
    }

    let len = arg.length;
    let ptr = malloc(len, 1) >>> 0;

    const mem = getUint8Memory0();

    let offset = 0;

    for (; offset < len; offset++) {
        const code = arg.charCodeAt(offset);
        if (code > 0x7F) break;
        mem[ptr + offset] = code;
    }

    if (offset !== len) {
        if (offset !== 0) {
            arg = arg.slice(offset);
        }
        ptr = realloc(ptr, len, len = offset + arg.length * 3, 1) >>> 0;
        const view = getUint8Memory0().subarray(ptr + offset, ptr + len);
        const ret = encodeString(arg, view);

        offset += ret.written;
        ptr = realloc(ptr, len, offset, 1) >>> 0;
    }

    WASM_VECTOR_LEN = offset;
    return ptr;
}

function isLikeNone(x) {
    return x === undefined || x === null;
}

let cachedInt32Memory0 = null;

function getInt32Memory0() {
    if (cachedInt32Memory0 === null || cachedInt32Memory0.byteLength === 0) {
        cachedInt32Memory0 = new Int32Array(wasm.memory.buffer);
    }
    return cachedInt32Memory0;
}

function dropObject(idx) {
    if (idx < 132) return;
    heap[idx] = heap_next;
    heap_next = idx;
}

function takeObject(idx) {
    const ret = getObject(idx);
    dropObject(idx);
    return ret;
}

function debugString(val) {
    // primitive types
    const type = typeof val;
    if (type == 'number' || type == 'boolean' || val == null) {
        return  `${val}`;
    }
    if (type == 'string') {
        return `"${val}"`;
    }
    if (type == 'symbol') {
        const description = val.description;
        if (description == null) {
            return 'Symbol';
        } else {
            return `Symbol(${description})`;
        }
    }
    if (type == 'function') {
        const name = val.name;
        if (typeof name == 'string' && name.length > 0) {
            return `Function(${name})`;
        } else {
            return 'Function';
        }
    }
    // objects
    if (Array.isArray(val)) {
        const length = val.length;
        let debug = '[';
        if (length > 0) {
            debug += debugString(val[0]);
        }
        for(let i = 1; i < length; i++) {
            debug += ', ' + debugString(val[i]);
        }
        debug += ']';
        return debug;
    }
    // Test for built-in
    const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
    let className;
    if (builtInMatches.length > 1) {
        className = builtInMatches[1];
    } else {
        // Failed to match the standard '[object ClassName]'
        return toString.call(val);
    }
    if (className == 'Object') {
        // we're a user defined class or Object
        // JSON.stringify avoids problems with cycles, and is generally much
        // easier than looping through ownProperties of `val`.
        try {
            return 'Object(' + JSON.stringify(val) + ')';
        } catch (_) {
            return 'Object';
        }
    }
    // errors
    if (val instanceof Error) {
        return `${val.name}: ${val.message}\n${val.stack}`;
    }
    // TODO we could test for more things here, like `Set`s and `Map`s.
    return className;
}

const CLOSURE_DTORS = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(state => {
    wasm.__wbindgen_export_2.get(state.dtor)(state.a, state.b)
});

function makeMutClosure(arg0, arg1, dtor, f) {
    const state = { a: arg0, b: arg1, cnt: 1, dtor };
    const real = (...args) => {
        // First up with a closure we increment the internal reference
        // count. This ensures that the Rust closure environment won't
        // be deallocated while we're invoking it.
        state.cnt++;
        const a = state.a;
        state.a = 0;
        try {
            return f(a, state.b, ...args);
        } finally {
            if (--state.cnt === 0) {
                wasm.__wbindgen_export_2.get(state.dtor)(a, state.b);
                CLOSURE_DTORS.unregister(state);
            } else {
                state.a = a;
            }
        }
    };
    real.original = state;
    CLOSURE_DTORS.register(real, state, state);
    return real;
}
function __wbg_adapter_34(arg0, arg1) {
    wasm.wasm_bindgen__convert__closures__invoke0_mut__h463a1e55565aa4cb(arg0, arg1);
}

function __wbg_adapter_37(arg0, arg1, arg2) {
    wasm.wasm_bindgen__convert__closures__invoke1_mut__hf115d3e93a3ac084(arg0, arg1, addHeapObject(arg2));
}

function __wbg_adapter_40(arg0, arg1, arg2) {
    try {
        const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
        wasm.wasm_bindgen__convert__closures__invoke1_mut__h370dabcee01f267d(retptr, arg0, arg1, addHeapObject(arg2));
        var r0 = getInt32Memory0()[retptr / 4 + 0];
        var r1 = getInt32Memory0()[retptr / 4 + 1];
        if (r1) {
            throw takeObject(r0);
        }
    } finally {
        wasm.__wbindgen_add_to_stack_pointer(16);
    }
}

function __wbg_adapter_43(arg0, arg1, arg2) {
    wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h30387ea8438b5b23(arg0, arg1, addHeapObject(arg2));
}

function __wbg_adapter_46(arg0, arg1) {
    wasm._dyn_core__ops__function__FnMut_____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h8a9ff85188b38467(arg0, arg1);
}

function __wbg_adapter_53(arg0, arg1) {
    wasm.wasm_bindgen__convert__closures__invoke0_mut__hbd1043e2a546a861(arg0, arg1);
}

function __wbg_adapter_56(arg0, arg1, arg2) {
    wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h07cdf04f91686053(arg0, arg1, addHeapObject(arg2));
}

function __wbg_adapter_59(arg0, arg1) {
    wasm.wasm_bindgen__convert__closures__invoke0_mut__h4b015f586ffe0911(arg0, arg1);
}

function __wbg_adapter_62(arg0, arg1) {
    wasm._dyn_core__ops__function__FnMut_____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__hd41475bf2893458b(arg0, arg1);
}

function __wbg_adapter_65(arg0, arg1, arg2) {
    wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h135d3d8843e03526(arg0, arg1, addHeapObject(arg2));
}

function __wbg_adapter_72(arg0, arg1) {
    wasm.wasm_bindgen__convert__closures__invoke0_mut__h3160a2bdd1210410(arg0, arg1);
}

function __wbg_adapter_75(arg0, arg1, arg2) {
    wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h4394c7dd5ab2947c(arg0, arg1, addHeapObject(arg2));
}

let cachedBigInt64Memory0 = null;

function getBigInt64Memory0() {
    if (cachedBigInt64Memory0 === null || cachedBigInt64Memory0.byteLength === 0) {
        cachedBigInt64Memory0 = new BigInt64Array(wasm.memory.buffer);
    }
    return cachedBigInt64Memory0;
}

let cachedUint32Memory0 = null;

function getUint32Memory0() {
    if (cachedUint32Memory0 === null || cachedUint32Memory0.byteLength === 0) {
        cachedUint32Memory0 = new Uint32Array(wasm.memory.buffer);
    }
    return cachedUint32Memory0;
}

function getArrayJsValueFromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    const mem = getUint32Memory0();
    const slice = mem.subarray(ptr / 4, ptr / 4 + len);
    const result = [];
    for (let i = 0; i < slice.length; i++) {
        result.push(takeObject(slice[i]));
    }
    return result;
}
/**
* @returns {Promise<void>}
*/
export function main_js() {
    wasm.main_js();
}

function passArrayJsValueToWasm0(array, malloc) {
    const ptr = malloc(array.length * 4, 4) >>> 0;
    const mem = getUint32Memory0();
    for (let i = 0; i < array.length; i++) {
        mem[ptr / 4 + i] = addHeapObject(array[i]);
    }
    WASM_VECTOR_LEN = array.length;
    return ptr;
}

function handleError(f, args) {
    try {
        return f.apply(this, args);
    } catch (e) {
        wasm.__wbindgen_exn_store(addHeapObject(e));
    }
}

function getArrayU8FromWasm0(ptr, len) {
    ptr = ptr >>> 0;
    return getUint8Memory0().subarray(ptr / 1, ptr / 1 + len);
}
function __wbg_adapter_675(arg0, arg1, arg2, arg3) {
    wasm.wasm_bindgen__convert__closures__invoke2_mut__h8c5420bd2fdd24df(arg0, arg1, addHeapObject(arg2), addHeapObject(arg3));
}

/**
*/
export const TagKind = Object.freeze({ Label:0,"0":"Label",Contact:1,"1":"Contact", });
/**
*/
export const BudgetPeriod = Object.freeze({ Day:0,"0":"Day",Week:1,"1":"Week",Month:2,"2":"Month",Year:3,"3":"Year", });
/**
*/
export const ActivityType = Object.freeze({ OnChain:0,"0":"OnChain",Lightning:1,"1":"Lightning",ChannelOpen:2,"2":"ChannelOpen",ChannelClose:3,"3":"ChannelClose", });

const ActivityItemFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_activityitem_free(ptr >>> 0));
/**
*/
export class ActivityItem {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ActivityItemFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_activityitem_free(ptr);
    }
    /**
    * @returns {ActivityType}
    */
    get kind() {
        const ret = wasm.__wbg_get_activityitem_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {ActivityType} arg0
    */
    set kind(arg0) {
        wasm.__wbg_set_activityitem_kind(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint | undefined}
    */
    get amount_sats() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_activityitem_amount_sats(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint | undefined} [arg0]
    */
    set amount_sats(arg0) {
        wasm.__wbg_set_activityitem_amount_sats(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? BigInt(0) : arg0);
    }
    /**
    * @returns {boolean}
    */
    get inbound() {
        const ret = wasm.__wbg_get_activityitem_inbound(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set inbound(arg0) {
        wasm.__wbg_set_activityitem_inbound(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint | undefined}
    */
    get last_updated() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_activityitem_last_updated(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint | undefined} [arg0]
    */
    set last_updated(arg0) {
        wasm.__wbg_set_activityitem_last_updated(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? BigInt(0) : arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.activityitem_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.activityitem_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {(string)[]}
    */
    get labels() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.activityitem_labels(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {(TagItem)[]}
    */
    get contacts() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.activityitem_contacts(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const AuthProfileFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_authprofile_free(ptr >>> 0));
/**
*/
export class AuthProfile {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        AuthProfileFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_authprofile_free(ptr);
    }
    /**
    * @returns {number}
    */
    get index() {
        const ret = wasm.__wbg_get_authprofile_index(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} arg0
    */
    set index(arg0) {
        wasm.__wbg_set_authprofile_index(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.authprofile_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.authprofile_name(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {(string)[]}
    */
    get used_services() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.authprofile_used_services(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const ChannelClosureFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_channelclosure_free(ptr >>> 0));
/**
* Information about a channel that was closed.
*/
export class ChannelClosure {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(ChannelClosure.prototype);
        obj.__wbg_ptr = ptr;
        ChannelClosureFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        ChannelClosureFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_channelclosure_free(ptr);
    }
    /**
    * @returns {bigint}
    */
    get timestamp() {
        const ret = wasm.__wbg_get_channelclosure_timestamp(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set timestamp(arg0) {
        wasm.__wbg_set_channelclosure_timestamp(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.channelclosure_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string | undefined}
    */
    get channel_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.channelclosure_channel_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get node_id() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.channelclosure_node_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get reason() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.channelclosure_reason(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const FederationBalanceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_federationbalance_free(ptr >>> 0));
/**
*/
export class FederationBalance {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FederationBalance.prototype);
        obj.__wbg_ptr = ptr;
        FederationBalanceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FederationBalanceFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_federationbalance_free(ptr);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.federationbalance_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get identity_uuid() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.federationbalance_identity_uuid(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get identity_federation_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.federationbalance_identity_federation_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {bigint}
    */
    get balance() {
        const ret = wasm.federationbalance_balance(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
}

const FederationBalancesFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_federationbalances_free(ptr >>> 0));
/**
*/
export class FederationBalances {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FederationBalances.prototype);
        obj.__wbg_ptr = ptr;
        FederationBalancesFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FederationBalancesFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_federationbalances_free(ptr);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.federationbalances_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {(FederationBalance)[]}
    */
    get balances() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.federationbalances_balances(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const FederationIdentityFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_federationidentity_free(ptr >>> 0));
/**
*/
export class FederationIdentity {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FederationIdentity.prototype);
        obj.__wbg_ptr = ptr;
        FederationIdentityFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FederationIdentityFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_federationidentity_free(ptr);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.federationidentity_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get uuid() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.federationidentity_uuid(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get federation_code() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.federationidentity_federation_code(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const FedimintSweepResultFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_fedimintsweepresult_free(ptr >>> 0));
/**
* FedimintSweepResult is the result of how much was swept and the fees paid.
*/
export class FedimintSweepResult {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(FedimintSweepResult.prototype);
        obj.__wbg_ptr = ptr;
        FedimintSweepResultFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        FedimintSweepResultFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_fedimintsweepresult_free(ptr);
    }
    /**
    * @returns {bigint}
    */
    get amount() {
        const ret = wasm.__wbg_get_fedimintsweepresult_amount(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set amount(arg0) {
        wasm.__wbg_set_fedimintsweepresult_amount(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint | undefined}
    */
    get fees() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_fedimintsweepresult_fees(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint | undefined} [arg0]
    */
    set fees(arg0) {
        wasm.__wbg_set_fedimintsweepresult_fees(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? BigInt(0) : arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.fedimintsweepresult_value(this.__wbg_ptr);
        return takeObject(ret);
    }
}

const LnUrlParamsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_lnurlparams_free(ptr >>> 0));
/**
*/
export class LnUrlParams {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(LnUrlParams.prototype);
        obj.__wbg_ptr = ptr;
        LnUrlParamsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        LnUrlParamsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_lnurlparams_free(ptr);
    }
    /**
    * @returns {bigint}
    */
    get max() {
        const ret = wasm.__wbg_get_lnurlparams_max(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set max(arg0) {
        wasm.__wbg_set_lnurlparams_max(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get min() {
        const ret = wasm.__wbg_get_lnurlparams_min(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set min(arg0) {
        wasm.__wbg_set_lnurlparams_min(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.lnurlparams_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get tag() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.lnurlparams_tag(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const MutinyBalanceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mutinybalance_free(ptr >>> 0));
/**
*/
export class MutinyBalance {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MutinyBalance.prototype);
        obj.__wbg_ptr = ptr;
        MutinyBalanceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MutinyBalanceFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mutinybalance_free(ptr);
    }
    /**
    * @returns {bigint}
    */
    get confirmed() {
        const ret = wasm.__wbg_get_mutinybalance_confirmed(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set confirmed(arg0) {
        wasm.__wbg_set_mutinybalance_confirmed(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get unconfirmed() {
        const ret = wasm.__wbg_get_mutinybalance_unconfirmed(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set unconfirmed(arg0) {
        wasm.__wbg_set_mutinybalance_unconfirmed(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get lightning() {
        const ret = wasm.__wbg_get_mutinybalance_lightning(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set lightning(arg0) {
        wasm.__wbg_set_mutinybalance_lightning(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get federation() {
        const ret = wasm.__wbg_get_mutinybalance_federation(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set federation(arg0) {
        wasm.__wbg_set_mutinybalance_federation(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get force_close() {
        const ret = wasm.__wbg_get_mutinybalance_force_close(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set force_close(arg0) {
        wasm.__wbg_set_mutinybalance_force_close(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.mutinybalance_value(this.__wbg_ptr);
        return takeObject(ret);
    }
}

const MutinyBip21RawMaterialsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mutinybip21rawmaterials_free(ptr >>> 0));
/**
*/
export class MutinyBip21RawMaterials {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MutinyBip21RawMaterials.prototype);
        obj.__wbg_ptr = ptr;
        MutinyBip21RawMaterialsFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MutinyBip21RawMaterialsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mutinybip21rawmaterials_free(ptr);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.mutinybip21rawmaterials_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get address() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinybip21rawmaterials_address(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get invoice() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinybip21rawmaterials_invoice(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get btc_amount() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinybip21rawmaterials_btc_amount(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {(string)[]}
    */
    get labels() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinybip21rawmaterials_labels(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const MutinyChannelFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mutinychannel_free(ptr >>> 0));
/**
*/
export class MutinyChannel {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MutinyChannel.prototype);
        obj.__wbg_ptr = ptr;
        MutinyChannelFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MutinyChannelFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mutinychannel_free(ptr);
    }
    /**
    * @returns {bigint}
    */
    get balance() {
        const ret = wasm.__wbg_get_mutinychannel_balance(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set balance(arg0) {
        wasm.__wbg_set_mutinychannel_balance(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get size() {
        const ret = wasm.__wbg_get_mutinychannel_size(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set size(arg0) {
        wasm.__wbg_set_mutinychannel_size(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get reserve() {
        const ret = wasm.__wbg_get_mutinychannel_reserve(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set reserve(arg0) {
        wasm.__wbg_set_mutinychannel_reserve(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get inbound() {
        const ret = wasm.__wbg_get_mutinychannel_inbound(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set inbound(arg0) {
        wasm.__wbg_set_mutinychannel_inbound(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {number | undefined}
    */
    get confirmations_required() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_mutinychannel_confirmations_required(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return r0 === 0 ? undefined : r1 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {number | undefined} [arg0]
    */
    set confirmations_required(arg0) {
        wasm.__wbg_set_mutinychannel_confirmations_required(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? 0 : arg0);
    }
    /**
    * @returns {number}
    */
    get confirmations() {
        const ret = wasm.__wbg_get_mutinychannel_confirmations(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} arg0
    */
    set confirmations(arg0) {
        wasm.__wbg_set_mutinychannel_confirmations(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get is_outbound() {
        const ret = wasm.__wbg_get_mutinychannel_is_outbound(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_outbound(arg0) {
        wasm.__wbg_set_mutinychannel_is_outbound(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get is_usable() {
        const ret = wasm.__wbg_get_mutinychannel_is_usable(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_usable(arg0) {
        wasm.__wbg_set_mutinychannel_is_usable(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get is_anchor() {
        const ret = wasm.__wbg_get_mutinychannel_is_anchor(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_anchor(arg0) {
        wasm.__wbg_set_mutinychannel_is_anchor(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.mutinychannel_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get user_chan_id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinychannel_user_chan_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get outpoint() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinychannel_outpoint(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get peer() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinychannel_peer(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {boolean}
    */
    get confirmed() {
        const ret = wasm.mutinychannel_confirmed(this.__wbg_ptr);
        return ret !== 0;
    }
}

const MutinyInvoiceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mutinyinvoice_free(ptr >>> 0));
/**
*/
export class MutinyInvoice {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MutinyInvoice.prototype);
        obj.__wbg_ptr = ptr;
        MutinyInvoiceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MutinyInvoiceFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mutinyinvoice_free(ptr);
    }
    /**
    * @returns {bigint | undefined}
    */
    get amount_sats() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_mutinyinvoice_amount_sats(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint | undefined} [arg0]
    */
    set amount_sats(arg0) {
        wasm.__wbg_set_mutinyinvoice_amount_sats(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? BigInt(0) : arg0);
    }
    /**
    * @returns {bigint}
    */
    get expire() {
        const ret = wasm.__wbg_get_mutinyinvoice_expire(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set expire(arg0) {
        wasm.__wbg_set_mutinyinvoice_expire(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get expired() {
        const ret = wasm.__wbg_get_mutinyinvoice_expired(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set expired(arg0) {
        wasm.__wbg_set_mutinyinvoice_expired(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint | undefined}
    */
    get fees_paid() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_mutinyinvoice_fees_paid(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {bigint | undefined} [arg0]
    */
    set fees_paid(arg0) {
        wasm.__wbg_set_mutinyinvoice_fees_paid(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? BigInt(0) : arg0);
    }
    /**
    * @returns {boolean}
    */
    get inbound() {
        const ret = wasm.__wbg_get_mutinyinvoice_inbound(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set inbound(arg0) {
        wasm.__wbg_set_mutinyinvoice_inbound(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get last_updated() {
        const ret = wasm.__wbg_get_mutinyinvoice_last_updated(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set last_updated(arg0) {
        wasm.__wbg_set_mutinyinvoice_last_updated(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {boolean}
    */
    get potential_hodl_invoice() {
        const ret = wasm.__wbg_get_mutinyinvoice_potential_hodl_invoice(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set potential_hodl_invoice(arg0) {
        wasm.__wbg_set_mutinyinvoice_potential_hodl_invoice(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.mutinyinvoice_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string | undefined}
    */
    get bolt11() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinyinvoice_bolt11(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get description() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinyinvoice_description(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get payment_hash() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinyinvoice_payment_hash(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get preimage() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinyinvoice_preimage(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get payee_pubkey() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinyinvoice_payee_pubkey(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get status() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinyinvoice_status(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get privacy_level() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinyinvoice_privacy_level(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {boolean}
    */
    get paid() {
        const ret = wasm.mutinyinvoice_paid(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {(string)[]}
    */
    get labels() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinyinvoice_labels(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const MutinyPeerFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mutinypeer_free(ptr >>> 0));
/**
*/
export class MutinyPeer {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MutinyPeerFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mutinypeer_free(ptr);
    }
    /**
    * @returns {boolean}
    */
    get is_connected() {
        const ret = wasm.__wbg_get_mutinypeer_is_connected(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @param {boolean} arg0
    */
    set is_connected(arg0) {
        wasm.__wbg_set_mutinypeer_is_connected(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.mutinypeer_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get pubkey() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinypeer_pubkey(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get connection_string() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinypeer_connection_string(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get alias() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinypeer_alias(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get color() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinypeer_color(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get label() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinypeer_label(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const MutinyWalletFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_mutinywallet_free(ptr >>> 0));
/**
*/
export class MutinyWallet {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(MutinyWallet.prototype);
        obj.__wbg_ptr = ptr;
        MutinyWalletFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        MutinyWalletFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_mutinywallet_free(ptr);
    }
    /**
    * Creates a new [MutinyWallet] with the given parameters.
    * The mnemonic seed is read from storage, unless one is provided.
    * If no mnemonic is provided, a new one is generated and stored.
    * @param {string | undefined} [password]
    * @param {string | undefined} [mnemonic_str]
    * @param {string | undefined} [websocket_proxy_addr]
    * @param {string | undefined} [network_str]
    * @param {string | undefined} [user_esplora_url]
    * @param {string | undefined} [user_rgs_url]
    * @param {string | undefined} [lsp_url]
    * @param {string | undefined} [lsp_connection_string]
    * @param {string | undefined} [lsp_token]
    * @param {string | undefined} [auth_url]
    * @param {string | undefined} [subscription_url]
    * @param {string | undefined} [storage_url]
    * @param {string | undefined} [scorer_url]
    * @param {boolean | undefined} [do_not_connect_peers]
    * @param {boolean | undefined} [skip_device_lock]
    * @param {boolean | undefined} [safe_mode]
    * @param {boolean | undefined} [skip_hodl_invoices]
    * @param {string | undefined} [nsec_override]
    * @param {string | undefined} [nip_07_key]
    * @param {string | undefined} [primal_url]
    * @param {string | undefined} [blind_auth_url]
    * @param {string | undefined} [hermes_url]
    * @returns {Promise<MutinyWallet>}
    */
    static new(password, mnemonic_str, websocket_proxy_addr, network_str, user_esplora_url, user_rgs_url, lsp_url, lsp_connection_string, lsp_token, auth_url, subscription_url, storage_url, scorer_url, do_not_connect_peers, skip_device_lock, safe_mode, skip_hodl_invoices, nsec_override, nip_07_key, primal_url, blind_auth_url, hermes_url) {
        var ptr0 = isLikeNone(password) ? 0 : passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(mnemonic_str) ? 0 : passStringToWasm0(mnemonic_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(websocket_proxy_addr) ? 0 : passStringToWasm0(websocket_proxy_addr, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(network_str) ? 0 : passStringToWasm0(network_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(user_esplora_url) ? 0 : passStringToWasm0(user_esplora_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        var ptr5 = isLikeNone(user_rgs_url) ? 0 : passStringToWasm0(user_rgs_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len5 = WASM_VECTOR_LEN;
        var ptr6 = isLikeNone(lsp_url) ? 0 : passStringToWasm0(lsp_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len6 = WASM_VECTOR_LEN;
        var ptr7 = isLikeNone(lsp_connection_string) ? 0 : passStringToWasm0(lsp_connection_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len7 = WASM_VECTOR_LEN;
        var ptr8 = isLikeNone(lsp_token) ? 0 : passStringToWasm0(lsp_token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len8 = WASM_VECTOR_LEN;
        var ptr9 = isLikeNone(auth_url) ? 0 : passStringToWasm0(auth_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len9 = WASM_VECTOR_LEN;
        var ptr10 = isLikeNone(subscription_url) ? 0 : passStringToWasm0(subscription_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len10 = WASM_VECTOR_LEN;
        var ptr11 = isLikeNone(storage_url) ? 0 : passStringToWasm0(storage_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len11 = WASM_VECTOR_LEN;
        var ptr12 = isLikeNone(scorer_url) ? 0 : passStringToWasm0(scorer_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len12 = WASM_VECTOR_LEN;
        var ptr13 = isLikeNone(nsec_override) ? 0 : passStringToWasm0(nsec_override, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len13 = WASM_VECTOR_LEN;
        var ptr14 = isLikeNone(nip_07_key) ? 0 : passStringToWasm0(nip_07_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len14 = WASM_VECTOR_LEN;
        var ptr15 = isLikeNone(primal_url) ? 0 : passStringToWasm0(primal_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len15 = WASM_VECTOR_LEN;
        var ptr16 = isLikeNone(blind_auth_url) ? 0 : passStringToWasm0(blind_auth_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len16 = WASM_VECTOR_LEN;
        var ptr17 = isLikeNone(hermes_url) ? 0 : passStringToWasm0(hermes_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len17 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_new(ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5, ptr6, len6, ptr7, len7, ptr8, len8, ptr9, len9, ptr10, len10, ptr11, len11, ptr12, len12, isLikeNone(do_not_connect_peers) ? 0xFFFFFF : do_not_connect_peers ? 1 : 0, isLikeNone(skip_device_lock) ? 0xFFFFFF : skip_device_lock ? 1 : 0, isLikeNone(safe_mode) ? 0xFFFFFF : safe_mode ? 1 : 0, isLikeNone(skip_hodl_invoices) ? 0xFFFFFF : skip_hodl_invoices ? 1 : 0, ptr13, len13, ptr14, len14, ptr15, len15, ptr16, len16, ptr17, len17);
        return takeObject(ret);
    }
    /**
    * @returns {boolean}
    */
    is_safe_mode() {
        const ret = wasm.mutinywallet_is_safe_mode(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * Returns if there is a saved wallet in storage.
    * This is checked by seeing if a mnemonic seed exists in storage.
    * @returns {Promise<boolean>}
    */
    static has_node_manager() {
        const ret = wasm.mutinywallet_has_node_manager();
        return takeObject(ret);
    }
    /**
    * Returns the number of remaining seconds until the device lock expires.
    * @param {string | undefined} [password]
    * @param {string | undefined} [auth_url]
    * @param {string | undefined} [storage_url]
    * @returns {Promise<bigint | undefined>}
    */
    static get_device_lock_remaining_secs(password, auth_url, storage_url) {
        var ptr0 = isLikeNone(password) ? 0 : passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(auth_url) ? 0 : passStringToWasm0(auth_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(storage_url) ? 0 : passStringToWasm0(storage_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_device_lock_remaining_secs(ptr0, len0, ptr1, len1, ptr2, len2);
        return takeObject(ret);
    }
    /**
    * Starts up all the nodes again.
    * Not needed after [NodeManager]'s `new()` function.
    * @returns {Promise<void>}
    */
    start() {
        const ret = wasm.mutinywallet_start(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Stops all of the nodes and background processes.
    * Returns after node has been stopped.
    * @returns {Promise<void>}
    */
    stop() {
        const ret = wasm.mutinywallet_stop(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Returns the mnemonic seed phrase for the wallet.
    * @returns {string}
    */
    show_seed() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_show_seed(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * Returns the user's npub
    * @returns {Promise<string>}
    */
    get_npub() {
        const ret = wasm.mutinywallet_get_npub(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Export the user's nostr secret key if available
    * @returns {Promise<string | undefined>}
    */
    export_nsec() {
        const ret = wasm.mutinywallet_export_nsec(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Change our active nostr keys to the given nsec
    * @param {string | undefined} [nsec]
    * @param {string | undefined} [extension_pk]
    * @returns {Promise<string>}
    */
    change_nostr_keys(nsec, extension_pk) {
        var ptr0 = isLikeNone(nsec) ? 0 : passStringToWasm0(nsec, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(extension_pk) ? 0 : passStringToWasm0(extension_pk, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_change_nostr_keys(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Returns the network of the wallet.
    * @returns {string}
    */
    get_network() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_get_network(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * Gets a new bitcoin address from the wallet.
    * Will generate a new address on every call.
    *
    * It is recommended to create a new address for every transaction.
    * @param {(string)[]} labels
    * @returns {Promise<MutinyBip21RawMaterials>}
    */
    get_new_address(labels) {
        const ptr0 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_new_address(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Creates a BIP 21 invoice. This creates a new address and a lightning invoice.
    * The lightning invoice may return errors related to the LSP. Check the error and
    * fallback to `get_new_address` and warn the user that Lightning is not available.
    *
    *
    * Errors that might be returned include:
    *
    * - [`MutinyJsError::LspGenericError`]: This is returned for various reasons, including if a
    *   request to the LSP server fails for any reason, or if the server returns
    *   a status other than 500 that can't be parsed into a `ProposalResponse`.
    *
    * - [`MutinyJsError::LspFundingError`]: Returned if the LSP server returns an error with
    *   a status of 500, indicating an "Internal Server Error", and a message
    *   stating "Cannot fund new channel at this time". This means that the LSP cannot support
    *   a new channel at this time.
    *
    * - [`MutinyJsError::LspAmountTooHighError`]: Returned if the LSP server returns an error with
    *   a status of 500, indicating an "Internal Server Error", and a message stating "Invoice
    *   amount is too high". This means that the LSP cannot support the amount that the user
    *   requested. The user should request a smaller amount from the LSP.
    *
    * - [`MutinyJsError::LspConnectionError`]: Returned if the LSP server returns an error with
    *   a status of 500, indicating an "Internal Server Error", and a message that starts with
    *   "Failed to connect to peer". This means that the LSP is not connected to our node.
    *
    * If the server returns a status of 500 with a different error message,
    * a [`MutinyJsError::LspGenericError`] is returned.
    * @param {bigint | undefined} amount
    * @param {(string)[]} labels
    * @returns {Promise<MutinyBip21RawMaterials>}
    */
    create_bip21(amount, labels) {
        const ptr0 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_create_bip21(this.__wbg_ptr, !isLikeNone(amount), isLikeNone(amount) ? BigInt(0) : amount, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Sends an on-chain transaction to the given address.
    * The amount is in satoshis and the fee rate is in sat/vbyte.
    *
    * If a fee rate is not provided, one will be used from the fee estimator.
    * @param {string} destination_address
    * @param {bigint} amount
    * @param {(string)[]} labels
    * @param {number | undefined} [fee_rate]
    * @returns {Promise<string>}
    */
    send_to_address(destination_address, amount, labels, fee_rate) {
        const ptr0 = passStringToWasm0(destination_address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_send_to_address(this.__wbg_ptr, ptr0, len0, amount, ptr1, len1, !isLikeNone(fee_rate), isLikeNone(fee_rate) ? 0 : fee_rate);
        return takeObject(ret);
    }
    /**
    * @param {string} payjoin_uri
    * @param {bigint} amount
    * @param {(string)[]} labels
    * @param {number | undefined} [fee_rate]
    * @returns {Promise<string>}
    */
    send_payjoin(payjoin_uri, amount, labels, fee_rate) {
        const ptr0 = passStringToWasm0(payjoin_uri, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_send_payjoin(this.__wbg_ptr, ptr0, len0, amount, ptr1, len1, !isLikeNone(fee_rate), isLikeNone(fee_rate) ? 0 : fee_rate);
        return takeObject(ret);
    }
    /**
    * Sweeps all the funds from the wallet to the given address.
    * The fee rate is in sat/vbyte.
    *
    * If a fee rate is not provided, one will be used from the fee estimator.
    * @param {string} destination_address
    * @param {(string)[]} labels
    * @param {number | undefined} [fee_rate]
    * @returns {Promise<string>}
    */
    sweep_wallet(destination_address, labels, fee_rate) {
        const ptr0 = passStringToWasm0(destination_address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_sweep_wallet(this.__wbg_ptr, ptr0, len0, ptr1, len1, !isLikeNone(fee_rate), isLikeNone(fee_rate) ? 0 : fee_rate);
        return takeObject(ret);
    }
    /**
    * Estimates the onchain fee for a transaction sending to the given address.
    * The amount is in satoshis and the fee rate is in sat/vbyte.
    * @param {string} destination_address
    * @param {bigint} amount
    * @param {number | undefined} [fee_rate]
    * @returns {Promise<bigint>}
    */
    estimate_tx_fee(destination_address, amount, fee_rate) {
        const ptr0 = passStringToWasm0(destination_address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_estimate_tx_fee(this.__wbg_ptr, ptr0, len0, amount, !isLikeNone(fee_rate), isLikeNone(fee_rate) ? 0 : fee_rate);
        return takeObject(ret);
    }
    /**
    * Estimates the onchain fee for a transaction sweep our on-chain balance
    * to the given address.
    *
    * The fee rate is in sat/vbyte.
    * @param {string} destination_address
    * @param {number | undefined} [fee_rate]
    * @returns {Promise<bigint>}
    */
    estimate_sweep_tx_fee(destination_address, fee_rate) {
        const ptr0 = passStringToWasm0(destination_address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_estimate_sweep_tx_fee(this.__wbg_ptr, ptr0, len0, !isLikeNone(fee_rate), isLikeNone(fee_rate) ? 0 : fee_rate);
        return takeObject(ret);
    }
    /**
    * Estimates the onchain fee for a opening a lightning channel.
    * The amount is in satoshis and the fee rate is in sat/vbyte.
    * @param {bigint} amount
    * @param {number | undefined} [fee_rate]
    * @returns {bigint}
    */
    estimate_channel_open_fee(amount, fee_rate) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_estimate_channel_open_fee(retptr, this.__wbg_ptr, amount, !isLikeNone(fee_rate), isLikeNone(fee_rate) ? 0 : fee_rate);
            var r0 = getBigInt64Memory0()[retptr / 8 + 0];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Estimates the onchain fee for sweeping our on-chain balance to open a lightning channel.
    * The fee rate is in sat/vbyte.
    * @param {number | undefined} [fee_rate]
    * @returns {bigint}
    */
    estimate_sweep_channel_open_fee(fee_rate) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_estimate_sweep_channel_open_fee(retptr, this.__wbg_ptr, !isLikeNone(fee_rate), isLikeNone(fee_rate) ? 0 : fee_rate);
            var r0 = getBigInt64Memory0()[retptr / 8 + 0];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Estimates the lightning fee for a transaction. Amount is either from the invoice
    * if one is available or a passed in amount (priority). It will try to predict either
    * sending the payment through a federation or through lightning, depending on balances.
    * The amount and fee is in satoshis.
    * Returns None if it has no good way to calculate fee.
    * @param {string | undefined} [invoice_str]
    * @param {bigint | undefined} [amt_sats]
    * @returns {Promise<bigint | undefined>}
    */
    estimate_ln_fee(invoice_str, amt_sats) {
        var ptr0 = isLikeNone(invoice_str) ? 0 : passStringToWasm0(invoice_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_estimate_ln_fee(this.__wbg_ptr, ptr0, len0, !isLikeNone(amt_sats), isLikeNone(amt_sats) ? BigInt(0) : amt_sats);
        return takeObject(ret);
    }
    /**
    * Bumps the given transaction by replacing the given tx with a transaction at
    * the new given fee rate in sats/vbyte
    * @param {string} txid
    * @param {number} fee_rate
    * @returns {Promise<string>}
    */
    bump_fee(txid, fee_rate) {
        const ptr0 = passStringToWasm0(txid, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_bump_fee(this.__wbg_ptr, ptr0, len0, fee_rate);
        return takeObject(ret);
    }
    /**
    * Checks if the given address has any transactions.
    * If it does, it returns the details of the first transaction.
    *
    * This should be used to check if a payment has been made to an address.
    * @param {string} address
    * @returns {Promise<any>}
    */
    check_address(address) {
        const ptr0 = passStringToWasm0(address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_check_address(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Gets the details of a specific on-chain transaction.
    * @param {string} txid
    * @returns {any}
    */
    get_transaction(txid) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(txid, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.mutinywallet_get_transaction(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Gets the current balance of the wallet.
    * This includes both on-chain and lightning funds.
    *
    * This will not include any funds in an unconfirmed lightning channel.
    * @returns {Promise<MutinyBalance>}
    */
    get_balance() {
        const ret = wasm.mutinywallet_get_balance(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Lists all the UTXOs in the wallet.
    * @returns {any}
    */
    list_utxos() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_list_utxos(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Gets a fee estimate for an low priority transaction.
    * Value is in sat/vbyte.
    * @returns {number}
    */
    estimate_fee_low() {
        const ret = wasm.mutinywallet_estimate_fee_low(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Gets a fee estimate for an average priority transaction.
    * Value is in sat/vbyte.
    * @returns {number}
    */
    estimate_fee_normal() {
        const ret = wasm.mutinywallet_estimate_fee_normal(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Gets a fee estimate for an high priority transaction.
    * Value is in sat/vbyte.
    * @returns {number}
    */
    estimate_fee_high() {
        const ret = wasm.mutinywallet_estimate_fee_high(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * Creates a new lightning node and adds it to the manager.
    * @returns {Promise<NodeIdentity>}
    */
    new_node() {
        const ret = wasm.mutinywallet_new_node(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Lists the pubkeys of the lightning node in the manager.
    * @returns {Promise<any>}
    */
    list_nodes() {
        const ret = wasm.mutinywallet_list_nodes(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Changes all the node's LSPs to the given config. If any of the nodes have an active channel with the
    * current LSP, it will fail to change the LSP.
    *
    * Requires a restart of the node manager to take effect.
    * @param {string | undefined} [lsp_url]
    * @param {string | undefined} [lsp_connection_string]
    * @param {string | undefined} [lsp_token]
    * @returns {Promise<void>}
    */
    change_lsp(lsp_url, lsp_connection_string, lsp_token) {
        var ptr0 = isLikeNone(lsp_url) ? 0 : passStringToWasm0(lsp_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(lsp_connection_string) ? 0 : passStringToWasm0(lsp_connection_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(lsp_token) ? 0 : passStringToWasm0(lsp_token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_change_lsp(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2);
        return takeObject(ret);
    }
    /**
    * Attempts to connect to a peer from the selected node.
    * @param {string} connection_string
    * @param {string | undefined} [label]
    * @returns {Promise<void>}
    */
    connect_to_peer(connection_string, label) {
        const ptr0 = passStringToWasm0(connection_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(label) ? 0 : passStringToWasm0(label, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_connect_to_peer(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Disconnects from a peer from the selected node.
    * @param {string} peer
    * @returns {Promise<void>}
    */
    disconnect_peer(peer) {
        const ptr0 = passStringToWasm0(peer, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_disconnect_peer(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Deletes a peer from the selected node.
    * This will make it so that the node will not attempt to
    * reconnect to the peer.
    * @param {string} peer
    * @returns {Promise<void>}
    */
    delete_peer(peer) {
        const ptr0 = passStringToWasm0(peer, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_delete_peer(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Sets the label of a peer from the selected node.
    * @param {string} node_id
    * @param {string | undefined} [label]
    */
    label_peer(node_id, label) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(node_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(label) ? 0 : passStringToWasm0(label, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            wasm.mutinywallet_label_peer(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Creates a lightning invoice. The amount should be in satoshis.
    * If no amount is provided, the invoice will be created with no amount.
    * If no description is provided, the invoice will be created with no description.
    *
    * If the manager has more than one node it will create a phantom invoice.
    * If there is only one node it will create an invoice just for that node.
    * @param {bigint} amount
    * @param {(string)[]} labels
    * @returns {Promise<MutinyInvoice>}
    */
    create_invoice(amount, labels) {
        const ptr0 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_create_invoice(this.__wbg_ptr, amount, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Pays a lightning invoice from the selected node.
    * An amount should only be provided if the invoice does not have an amount.
    * The amount should be in satoshis.
    * @param {string} invoice_str
    * @param {bigint | undefined} amt_sats
    * @param {(string)[]} labels
    * @returns {Promise<MutinyInvoice>}
    */
    pay_invoice(invoice_str, amt_sats, labels) {
        const ptr0 = passStringToWasm0(invoice_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_pay_invoice(this.__wbg_ptr, ptr0, len0, !isLikeNone(amt_sats), isLikeNone(amt_sats) ? BigInt(0) : amt_sats, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Sends a spontaneous payment to a node from the selected node.
    * The amount should be in satoshis.
    * @param {string} to_node
    * @param {bigint} amt_sats
    * @param {string | undefined} message
    * @param {(string)[]} labels
    * @returns {Promise<MutinyInvoice>}
    */
    keysend(to_node, amt_sats, message, labels) {
        const ptr0 = passStringToWasm0(to_node, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(message) ? 0 : passStringToWasm0(message, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ptr2 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len2 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_keysend(this.__wbg_ptr, ptr0, len0, amt_sats, ptr1, len1, ptr2, len2);
        return takeObject(ret);
    }
    /**
    * Decodes a lightning invoice into useful information.
    * Will return an error if the invoice is for a different network.
    * @param {string} invoice
    * @param {string | undefined} [network]
    * @returns {Promise<MutinyInvoice>}
    */
    decode_invoice(invoice, network) {
        const ptr0 = passStringToWasm0(invoice, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(network) ? 0 : passStringToWasm0(network, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_decode_invoice(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Calls upon a LNURL to get the parameters for it.
    * This contains what kind of LNURL it is (pay, withdrawal, auth, etc).
    * @param {string} lnurl
    * @returns {Promise<LnUrlParams>}
    */
    decode_lnurl(lnurl) {
        const ptr0 = passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_decode_lnurl(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Calls upon a LNURL and pays it.
    * This will fail if the LNURL is not a LNURL pay.
    * @param {string} lnurl
    * @param {bigint} amount_sats
    * @param {string | undefined} zap_npub
    * @param {(string)[]} labels
    * @param {string | undefined} [comment]
    * @param {string | undefined} [privacy_level]
    * @returns {Promise<MutinyInvoice>}
    */
    lnurl_pay(lnurl, amount_sats, zap_npub, labels, comment, privacy_level) {
        const ptr0 = passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(zap_npub) ? 0 : passStringToWasm0(zap_npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ptr2 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
        const len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(comment) ? 0 : passStringToWasm0(comment, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        var ptr4 = isLikeNone(privacy_level) ? 0 : passStringToWasm0(privacy_level, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len4 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_lnurl_pay(this.__wbg_ptr, ptr0, len0, amount_sats, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
        return takeObject(ret);
    }
    /**
    * Calls upon a LNURL and withdraws from it.
    * This will fail if the LNURL is not a LNURL withdrawal.
    * @param {string} lnurl
    * @param {bigint} amount_sats
    * @returns {Promise<boolean>}
    */
    lnurl_withdraw(lnurl, amount_sats) {
        const ptr0 = passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_lnurl_withdraw(this.__wbg_ptr, ptr0, len0, amount_sats);
        return takeObject(ret);
    }
    /**
    * Calls upon a Cash mint and melts the token from it.
    * @param {string} maybe_token
    * @returns {Promise<any>}
    */
    melt_cashu_token(maybe_token) {
        const ptr0 = passStringToWasm0(maybe_token, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_melt_cashu_token(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Authenticates with a LNURL-auth for the given profile.
    * @param {string} lnurl
    * @returns {Promise<void>}
    */
    lnurl_auth(lnurl) {
        const ptr0 = passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_lnurl_auth(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Gets an invoice from the node manager.
    * This includes sent and received invoices.
    * @param {string} invoice
    * @returns {Promise<MutinyInvoice>}
    */
    get_invoice(invoice) {
        const ptr0 = passStringToWasm0(invoice, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_invoice(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Gets an invoice from the node manager.
    * This includes sent and received invoices.
    * @param {string} hash
    * @returns {Promise<MutinyInvoice>}
    */
    get_invoice_by_hash(hash) {
        const ptr0 = passStringToWasm0(hash, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_invoice_by_hash(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Gets an invoice from the node manager.
    * This includes sent and received invoices.
    * @returns {Promise<any>}
    */
    list_invoices() {
        const ret = wasm.mutinywallet_list_invoices(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Gets an channel closure from the node manager.
    * @param {string} user_channel_id
    * @returns {Promise<ChannelClosure>}
    */
    get_channel_closure(user_channel_id) {
        const ptr0 = passStringToWasm0(user_channel_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_channel_closure(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Gets all channel closures from the node manager.
    *
    * The channel closures are sorted by the time they were closed.
    * @returns {Promise<any>}
    */
    list_channel_closures() {
        const ret = wasm.mutinywallet_list_channel_closures(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Opens a channel from our selected node to the given pubkey.
    * The amount is in satoshis.
    *
    * The node must be online and have a connection to the peer.
    * The wallet much have enough funds to open the channel.
    * @param {string | undefined} to_pubkey
    * @param {bigint} amount
    * @param {number | undefined} [fee_rate]
    * @returns {Promise<MutinyChannel>}
    */
    open_channel(to_pubkey, amount, fee_rate) {
        var ptr0 = isLikeNone(to_pubkey) ? 0 : passStringToWasm0(to_pubkey, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_open_channel(this.__wbg_ptr, ptr0, len0, amount, !isLikeNone(fee_rate), isLikeNone(fee_rate) ? 0 : fee_rate);
        return takeObject(ret);
    }
    /**
    * Opens a channel from our selected node to the given pubkey.
    * It will spend the all the on-chain utxo in full to fund the channel.
    *
    * The node must be online and have a connection to the peer.
    * @param {string | undefined} [to_pubkey]
    * @returns {Promise<MutinyChannel>}
    */
    sweep_all_to_channel(to_pubkey) {
        var ptr0 = isLikeNone(to_pubkey) ? 0 : passStringToWasm0(to_pubkey, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_sweep_all_to_channel(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Sweep the federation balance into a lightning channel
    * @param {string | undefined} from_federation_id
    * @param {string} bolt_11
    * @returns {Promise<FedimintSweepResult>}
    */
    sweep_federation_balance_to_invoice(from_federation_id, bolt_11) {
        var ptr0 = isLikeNone(from_federation_id) ? 0 : passStringToWasm0(from_federation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(bolt_11, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_sweep_federation_balance_to_invoice(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Estimate the fee before trying to sweep from federation
    * @param {bigint | undefined} [amount]
    * @param {string | undefined} [from_federation_id]
    * @param {string | undefined} [to_federation_id]
    * @returns {Promise<MutinyInvoice>}
    */
    create_sweep_federation_invoice(amount, from_federation_id, to_federation_id) {
        var ptr0 = isLikeNone(from_federation_id) ? 0 : passStringToWasm0(from_federation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(to_federation_id) ? 0 : passStringToWasm0(to_federation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_create_sweep_federation_invoice(this.__wbg_ptr, !isLikeNone(amount), isLikeNone(amount) ? BigInt(0) : amount, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Closes a channel with the given outpoint.
    *
    * If force is true, the channel will be force closed.
    *
    * If abandon is true, the channel will be abandoned.
    * This will force close without broadcasting the latest transaction.
    * This should only be used if the channel will never actually be opened.
    *
    * If both force and abandon are true, an error will be returned.
    * @param {string} outpoint
    * @param {boolean} force
    * @param {boolean} abandon
    * @returns {Promise<void>}
    */
    close_channel(outpoint, force, abandon) {
        const ptr0 = passStringToWasm0(outpoint, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_close_channel(this.__wbg_ptr, ptr0, len0, force, abandon);
        return takeObject(ret);
    }
    /**
    * Lists all the channels for all the nodes in the node manager.
    * @returns {Promise<any>}
    */
    list_channels() {
        const ret = wasm.mutinywallet_list_channels(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Lists all the peers for all the nodes in the node manager.
    * @returns {Promise<any>}
    */
    list_peers() {
        const ret = wasm.mutinywallet_list_peers(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Returns all the on-chain and lightning activity from the wallet.
    * @param {number | undefined} [limit]
    * @param {number | undefined} [offset]
    * @returns {Promise<any>}
    */
    get_activity(limit, offset) {
        const ret = wasm.mutinywallet_get_activity(this.__wbg_ptr, !isLikeNone(limit), isLikeNone(limit) ? 0 : limit, !isLikeNone(offset), isLikeNone(offset) ? 0 : offset);
        return takeObject(ret);
    }
    /**
    * Returns all the on-chain and lightning activity for a given label
    * @param {string} label
    * @returns {Promise<any>}
    */
    get_label_activity(label) {
        const ptr0 = passStringToWasm0(label, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_label_activity(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Adds a new federation based on its federation code
    * @param {string} federation_code
    * @returns {Promise<FederationIdentity>}
    */
    new_federation(federation_code) {
        const ptr0 = passStringToWasm0(federation_code, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_new_federation(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Lists the federation id's of the federation clients in the manager.
    * @returns {Promise<any>}
    */
    list_federations() {
        const ret = wasm.mutinywallet_list_federations(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Removes a federation by setting its archived status to true, based on the FederationId.
    * @param {string} federation_id
    * @returns {Promise<void>}
    */
    remove_federation(federation_id) {
        const ptr0 = passStringToWasm0(federation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_remove_federation(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Gets the current balances of each federation.
    * @returns {Promise<FederationBalances>}
    */
    get_federation_balances() {
        const ret = wasm.mutinywallet_get_federation_balances(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Creates a recommendation event for a federation
    * @param {string} invite_code
    * @param {string | undefined} [review]
    * @returns {Promise<string>}
    */
    recommend_federation(invite_code, review) {
        const ptr0 = passStringToWasm0(invite_code, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(review) ? 0 : passStringToWasm0(review, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_recommend_federation(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Checks if we have recommended the given federation
    * @param {string} federation_id
    * @returns {Promise<boolean>}
    */
    has_recommended_federation(federation_id) {
        const ptr0 = passStringToWasm0(federation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_has_recommended_federation(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Creates a delete event for a federation recommendation
    * @param {string} federation_id
    * @returns {Promise<void>}
    */
    delete_federation_recommendation(federation_id) {
        const ptr0 = passStringToWasm0(federation_id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_delete_federation_recommendation(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Queries our relays for federation announcements
    * @returns {Promise<any>}
    */
    discover_federations() {
        const ret = wasm.mutinywallet_discover_federations(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {any}
    */
    get_address_labels() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_get_address_labels(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Set the labels for an address, replacing any existing labels
    * If you want to do not want to replace any existing labels, use `get_address_labels` to get the existing labels,
    * add the new labels, and then use `set_address_labels` to set the new labels
    * @param {string} address
    * @param {(string)[]} labels
    */
    set_address_labels(address, labels) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.mutinywallet_set_address_labels(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {any}
    */
    get_invoice_labels() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_get_invoice_labels(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Set the labels for an invoice, replacing any existing labels
    * If you want to do not want to replace any existing labels, use `get_invoice_labels` to get the existing labels,
    * add the new labels, and then use `set_invoice_labels` to set the new labels
    * @param {string} invoice
    * @param {(string)[]} labels
    */
    set_invoice_labels(invoice, labels) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(invoice, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passArrayJsValueToWasm0(labels, wasm.__wbindgen_malloc);
            const len1 = WASM_VECTOR_LEN;
            wasm.mutinywallet_set_invoice_labels(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {Promise<any>}
    */
    get_contacts() {
        const ret = wasm.mutinywallet_get_contacts(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Gets all contacts sorted by last used
    * @returns {Promise<any>}
    */
    get_contacts_sorted() {
        const ret = wasm.mutinywallet_get_contacts_sorted(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Get the contacts that are followed by the user sorted by last used
    * @returns {Promise<any>}
    */
    get_follows_sorted() {
        const ret = wasm.mutinywallet_get_follows_sorted(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @param {string} label
    * @returns {TagItem | undefined}
    */
    get_tag_item(label) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(label, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.mutinywallet_get_tag_item(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return r0 === 0 ? undefined : TagItem.__wrap(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Create a new contact from an existing label and returns the new identifying label
    * @param {string} label
    * @param {string} name
    * @param {string | undefined} [npub]
    * @param {string | undefined} [ln_address]
    * @param {string | undefined} [lnurl]
    * @param {string | undefined} [image_url]
    * @returns {string}
    */
    create_contact_from_label(label, name, npub, ln_address, lnurl, image_url) {
        let deferred8_0;
        let deferred8_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(label, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(npub) ? 0 : passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len2 = WASM_VECTOR_LEN;
            var ptr3 = isLikeNone(ln_address) ? 0 : passStringToWasm0(ln_address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len3 = WASM_VECTOR_LEN;
            var ptr4 = isLikeNone(lnurl) ? 0 : passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len4 = WASM_VECTOR_LEN;
            var ptr5 = isLikeNone(image_url) ? 0 : passStringToWasm0(image_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len5 = WASM_VECTOR_LEN;
            wasm.mutinywallet_create_contact_from_label(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            var ptr7 = r0;
            var len7 = r1;
            if (r3) {
                ptr7 = 0; len7 = 0;
                throw takeObject(r2);
            }
            deferred8_0 = ptr7;
            deferred8_1 = len7;
            return getStringFromWasm0(ptr7, len7);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred8_0, deferred8_1, 1);
        }
    }
    /**
    * @param {string} name
    * @param {string | undefined} [npub]
    * @param {string | undefined} [ln_address]
    * @param {string | undefined} [lnurl]
    * @param {string | undefined} [image_url]
    * @returns {string}
    */
    create_new_contact(name, npub, ln_address, lnurl, image_url) {
        let deferred7_0;
        let deferred7_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            var ptr1 = isLikeNone(npub) ? 0 : passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(ln_address) ? 0 : passStringToWasm0(ln_address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len2 = WASM_VECTOR_LEN;
            var ptr3 = isLikeNone(lnurl) ? 0 : passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len3 = WASM_VECTOR_LEN;
            var ptr4 = isLikeNone(image_url) ? 0 : passStringToWasm0(image_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len4 = WASM_VECTOR_LEN;
            wasm.mutinywallet_create_new_contact(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            var ptr6 = r0;
            var len6 = r1;
            if (r3) {
                ptr6 = 0; len6 = 0;
                throw takeObject(r2);
            }
            deferred7_0 = ptr6;
            deferred7_1 = len6;
            return getStringFromWasm0(ptr6, len6);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred7_0, deferred7_1, 1);
        }
    }
    /**
    * @param {string} id
    */
    delete_contact(id) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.mutinywallet_delete_contact(retptr, this.__wbg_ptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} id
    * @param {string} name
    * @param {string | undefined} [npub]
    * @param {string | undefined} [ln_address]
    * @param {string | undefined} [lnurl]
    * @param {string | undefined} [image_url]
    */
    edit_contact(id, name, npub, ln_address, lnurl, image_url) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(id, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            const ptr1 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len1 = WASM_VECTOR_LEN;
            var ptr2 = isLikeNone(npub) ? 0 : passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len2 = WASM_VECTOR_LEN;
            var ptr3 = isLikeNone(ln_address) ? 0 : passStringToWasm0(ln_address, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len3 = WASM_VECTOR_LEN;
            var ptr4 = isLikeNone(lnurl) ? 0 : passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len4 = WASM_VECTOR_LEN;
            var ptr5 = isLikeNone(image_url) ? 0 : passStringToWasm0(image_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            var len5 = WASM_VECTOR_LEN;
            wasm.mutinywallet_edit_contact(retptr, this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3, ptr4, len4, ptr5, len5);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            if (r1) {
                throw takeObject(r0);
            }
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} npub
    * @returns {Promise<TagItem | undefined>}
    */
    get_contact_for_npub(npub) {
        const ptr0 = passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_contact_for_npub(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * @returns {(TagItem)[]}
    */
    get_tag_items() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_get_tag_items(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Gets the current bitcoin price in chosen Fiat.
    * @param {string | undefined} [fiat]
    * @returns {Promise<number>}
    */
    get_bitcoin_price(fiat) {
        var ptr0 = isLikeNone(fiat) ? 0 : passStringToWasm0(fiat, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_bitcoin_price(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Exports the current state of the node manager to a json object.
    * @returns {Promise<any>}
    */
    static get_logs() {
        const ret = wasm.mutinywallet_get_logs();
        return takeObject(ret);
    }
    /**
    * Get nostr wallet connect profiles
    * @returns {(NwcProfile)[]}
    */
    get_nwc_profiles() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_get_nwc_profiles(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Create a nostr wallet connect profile
    * @param {string} name
    * @param {(string)[] | undefined} [commands]
    * @returns {Promise<NwcProfile>}
    */
    create_nwc_profile(name, commands) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(commands) ? 0 : passArrayJsValueToWasm0(commands, wasm.__wbindgen_malloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_create_nwc_profile(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Create a budgeted nostr wallet connect profile
    * @param {string} name
    * @param {bigint} budget
    * @param {BudgetPeriod} period
    * @param {bigint | undefined} [single_max]
    * @param {(string)[] | undefined} [commands]
    * @returns {Promise<NwcProfile>}
    */
    create_budget_nwc_profile(name, budget, period, single_max, commands) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(commands) ? 0 : passArrayJsValueToWasm0(commands, wasm.__wbindgen_malloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_create_budget_nwc_profile(this.__wbg_ptr, ptr0, len0, budget, period, !isLikeNone(single_max), isLikeNone(single_max) ? BigInt(0) : single_max, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Approves a nostr wallet auth request.
    * Creates a new NWC profile and saves to storage.
    * This will also broadcast the info event to the relay.
    * @param {string} name
    * @param {string} uri
    * @returns {Promise<NwcProfile>}
    */
    approve_nostr_wallet_auth(name, uri) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(uri, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_approve_nostr_wallet_auth(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Approves a nostr wallet auth request.
    * Creates a new NWC profile and saves to storage.
    * This will also broadcast the info event to the relay.
    * @param {string} name
    * @param {string} uri
    * @param {bigint} budget
    * @param {BudgetPeriod} period
    * @returns {Promise<NwcProfile>}
    */
    approve_nostr_wallet_auth_with_budget(name, uri, budget, period) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(uri, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_approve_nostr_wallet_auth_with_budget(this.__wbg_ptr, ptr0, len0, ptr1, len1, budget, period);
        return takeObject(ret);
    }
    /**
    * Deletes a nostr wallet connect profile
    * @param {number} profile_index
    * @returns {Promise<void>}
    */
    delete_nwc_profile(profile_index) {
        const ret = wasm.mutinywallet_delete_nwc_profile(this.__wbg_ptr, profile_index);
        return takeObject(ret);
    }
    /**
    * Set budget for a NWC Profile
    * @param {number} profile_index
    * @param {bigint} budget_sats
    * @param {BudgetPeriod} period
    * @param {bigint | undefined} [single_max_sats]
    * @returns {Promise<NwcProfile>}
    */
    set_nwc_profile_budget(profile_index, budget_sats, period, single_max_sats) {
        const ret = wasm.mutinywallet_set_nwc_profile_budget(this.__wbg_ptr, profile_index, budget_sats, period, !isLikeNone(single_max_sats), isLikeNone(single_max_sats) ? BigInt(0) : single_max_sats);
        return takeObject(ret);
    }
    /**
    * Require approval for a NWC Profile
    * @param {number} profile_index
    * @returns {Promise<NwcProfile>}
    */
    set_nwc_profile_require_approval(profile_index) {
        const ret = wasm.mutinywallet_set_nwc_profile_require_approval(this.__wbg_ptr, profile_index);
        return takeObject(ret);
    }
    /**
    * Finds a nostr wallet connect profile by index
    * @param {number} index
    * @returns {Promise<NwcProfile>}
    */
    get_nwc_profile(index) {
        const ret = wasm.mutinywallet_get_nwc_profile(this.__wbg_ptr, index);
        return takeObject(ret);
    }
    /**
    * Create a single use nostr wallet connect profile
    * @param {string} name
    * @param {bigint} amount_sats
    * @returns {Promise<NwcProfile>}
    */
    create_single_use_nwc(name, amount_sats) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_create_single_use_nwc(this.__wbg_ptr, ptr0, len0, amount_sats);
        return takeObject(ret);
    }
    /**
    * Create a single use nostr wallet connect profile
    * @param {bigint} amount_sats
    * @param {string} nwc_uri
    * @returns {Promise<string | undefined>}
    */
    claim_single_use_nwc(amount_sats, nwc_uri) {
        const ptr0 = passStringToWasm0(nwc_uri, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_claim_single_use_nwc(this.__wbg_ptr, amount_sats, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Get nostr wallet connect URI
    * @param {number} index
    * @returns {string | undefined}
    */
    get_nwc_uri(index) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_get_nwc_uri(retptr, this.__wbg_ptr, index);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Lists all pending NWC invoices
    * @returns {(PendingNwcInvoice)[]}
    */
    get_pending_nwc_invoices() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_get_pending_nwc_invoices(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Approves an invoice and sends the payment
    * @param {string} hash
    * @returns {Promise<void>}
    */
    approve_invoice(hash) {
        const ptr0 = passStringToWasm0(hash, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_approve_invoice(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Removes an invoice from the pending list, will also remove expired invoices
    * @param {string} hash
    * @returns {Promise<void>}
    */
    deny_invoice(hash) {
        const ptr0 = passStringToWasm0(hash, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_deny_invoice(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Removes all invoices from the pending list
    * @returns {Promise<void>}
    */
    deny_all_pending_nwc() {
        const ret = wasm.mutinywallet_deny_all_pending_nwc(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Checks whether or not the user is subscribed to Mutiny+.
    * Submits a NWC string to keep the subscription active if not expired.
    *
    * Returns None if there's no subscription at all.
    * Returns Some(u64) for their unix expiration timestamp, which may be in the
    * past or in the future, depending on whether or not it is currently active.
    * @returns {Promise<bigint | undefined>}
    */
    check_subscribed() {
        const ret = wasm.mutinywallet_check_subscribed(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Gets the subscription plans for Mutiny+ subscriptions
    * @returns {Promise<any>}
    */
    get_subscription_plans() {
        const ret = wasm.mutinywallet_get_subscription_plans(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Subscribes to a Mutiny+ plan with a specific plan id.
    *
    * Returns a lightning invoice so that the plan can be paid for to start it.
    * @param {number} id
    * @returns {Promise<MutinyInvoice>}
    */
    subscribe_to_plan(id) {
        const ret = wasm.mutinywallet_subscribe_to_plan(this.__wbg_ptr, id);
        return takeObject(ret);
    }
    /**
    * Pay the subscription invoice. This will post a NWC automatically afterwards.
    * @param {string} invoice_str
    * @param {boolean} autopay
    * @returns {Promise<void>}
    */
    pay_subscription_invoice(invoice_str, autopay) {
        const ptr0 = passStringToWasm0(invoice_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_pay_subscription_invoice(this.__wbg_ptr, ptr0, len0, autopay);
        return takeObject(ret);
    }
    /**
    * Returns the user's nostr profile data
    * @returns {any}
    */
    get_nostr_profile() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_get_nostr_profile(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            return takeObject(r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * This should only be called when the user is setting up a new profile
    * never for an existing profile
    * @param {string | undefined} [name]
    * @param {string | undefined} [img_url]
    * @param {string | undefined} [lnurl]
    * @param {string | undefined} [nip05]
    * @returns {Promise<any>}
    */
    setup_new_profile(name, img_url, lnurl, nip05) {
        var ptr0 = isLikeNone(name) ? 0 : passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(img_url) ? 0 : passStringToWasm0(img_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(lnurl) ? 0 : passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(nip05) ? 0 : passStringToWasm0(nip05, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_setup_new_profile(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        return takeObject(ret);
    }
    /**
    * Sets the user's nostr profile data
    * @param {string | undefined} [name]
    * @param {string | undefined} [img_url]
    * @param {string | undefined} [lnurl]
    * @param {string | undefined} [nip05]
    * @returns {Promise<any>}
    */
    edit_nostr_profile(name, img_url, lnurl, nip05) {
        var ptr0 = isLikeNone(name) ? 0 : passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(img_url) ? 0 : passStringToWasm0(img_url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        var ptr2 = isLikeNone(lnurl) ? 0 : passStringToWasm0(lnurl, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len2 = WASM_VECTOR_LEN;
        var ptr3 = isLikeNone(nip05) ? 0 : passStringToWasm0(nip05, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len3 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_edit_nostr_profile(this.__wbg_ptr, ptr0, len0, ptr1, len1, ptr2, len2, ptr3, len3);
        return takeObject(ret);
    }
    /**
    * Sets the user's nostr profile data to a "deleted" state
    * @returns {Promise<any>}
    */
    delete_profile() {
        const ret = wasm.mutinywallet_delete_profile(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Syncs all of our nostr data from the configured primal instance
    * @returns {Promise<void>}
    */
    sync_nostr() {
        const ret = wasm.mutinywallet_sync_nostr(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Get contacts from the given npub and sync them to the wallet
    * @param {string} npub_str
    * @returns {Promise<void>}
    */
    sync_nostr_contacts(npub_str) {
        const ptr0 = passStringToWasm0(npub_str, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_sync_nostr_contacts(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Gets the list of npubs we're following
    * @returns {Promise<any>}
    */
    get_follow_list() {
        const ret = wasm.mutinywallet_get_follow_list(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Follows the npub on nostr if we're not already following
    * @param {string} npub
    * @returns {Promise<void>}
    */
    follow_npub(npub) {
        const ptr0 = passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_follow_npub(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Unfollows the npub on nostr if we're following them
    *
    * Returns true if we were following them before
    * @param {string} npub
    * @returns {Promise<void>}
    */
    unfollow_npub(npub) {
        const ptr0 = passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_unfollow_npub(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Get dm conversation between us and given npub
    * Returns a vector of messages sorted by newest first
    * @param {string} npub
    * @param {bigint} limit
    * @param {bigint | undefined} [until]
    * @param {bigint | undefined} [since]
    * @returns {Promise<any>}
    */
    get_dm_conversation(npub, limit, until, since) {
        const ptr0 = passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_get_dm_conversation(this.__wbg_ptr, ptr0, len0, limit, !isLikeNone(until), isLikeNone(until) ? BigInt(0) : until, !isLikeNone(since), isLikeNone(since) ? BigInt(0) : since);
        return takeObject(ret);
    }
    /**
    * Sends a DM to the given npub
    * @param {string} npub
    * @param {string} message
    * @returns {Promise<string>}
    */
    send_dm(npub, message) {
        const ptr0 = passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ptr1 = passStringToWasm0(message, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_send_dm(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Uploads a profile pic to nostr.build and returns the uploaded file's URL
    * @param {string} img_base64
    * @returns {Promise<string>}
    */
    upload_profile_pic(img_base64) {
        const ptr0 = passStringToWasm0(img_base64, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_upload_profile_pic(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Checks if a given LNURL name is available
    * @param {string} name
    * @returns {Promise<boolean>}
    */
    check_available_lnurl_name(name) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_check_available_lnurl_name(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Reserves a given LNURL name for the user
    * @param {string} name
    * @returns {Promise<void>}
    */
    reserve_lnurl_name(name) {
        const ptr0 = passStringToWasm0(name, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_reserve_lnurl_name(this.__wbg_ptr, ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Checks the registered username for the user
    * @returns {Promise<string | undefined>}
    */
    check_lnurl_name() {
        const ret = wasm.mutinywallet_check_lnurl_name(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Resets the scorer and network graph. This can be useful if you get stuck in a bad state.
    * @returns {Promise<void>}
    */
    reset_router() {
        const ret = wasm.mutinywallet_reset_router(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Resets BDK's keychain tracker. This will require a re-sync of the blockchain.
    *
    * This can be useful if you get stuck in a bad state.
    * @returns {Promise<void>}
    */
    reset_onchain_tracker() {
        const ret = wasm.mutinywallet_reset_onchain_tracker(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Exports the current state of the node manager to a json object.
    * @param {string | undefined} [password]
    * @returns {Promise<string>}
    */
    static export_json(password) {
        var ptr0 = isLikeNone(password) ? 0 : passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_export_json(ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Restore a node manager from a json object.
    * @param {string} json
    * @returns {Promise<void>}
    */
    static import_json(json) {
        const ptr0 = passStringToWasm0(json, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_import_json(ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Clears storage and deletes all data.
    *
    * All data in VSS persists but the device lock is cleared.
    * @returns {Promise<void>}
    */
    delete_all() {
        const ret = wasm.mutinywallet_delete_all(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * Restore's the mnemonic after deleting the previous state.
    *
    * Backup the state beforehand. Does not restore lightning data.
    * Should refresh or restart afterwards. Wallet should be stopped.
    * @param {string} m
    * @param {string | undefined} [password]
    * @returns {Promise<void>}
    */
    static restore_mnemonic(m, password) {
        const ptr0 = passStringToWasm0(m, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(password) ? 0 : passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_restore_mnemonic(ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * @param {string | undefined} [old_password]
    * @param {string | undefined} [new_password]
    * @returns {Promise<void>}
    */
    change_password(old_password, new_password) {
        var ptr0 = isLikeNone(old_password) ? 0 : passStringToWasm0(old_password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len0 = WASM_VECTOR_LEN;
        var ptr1 = isLikeNone(new_password) ? 0 : passStringToWasm0(new_password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_change_password(this.__wbg_ptr, ptr0, len0, ptr1, len1);
        return takeObject(ret);
    }
    /**
    * Converts a bitcoin amount in BTC to satoshis.
    * @param {number} btc
    * @returns {bigint}
    */
    static convert_btc_to_sats(btc) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.mutinywallet_convert_btc_to_sats(retptr, btc);
            var r0 = getBigInt64Memory0()[retptr / 8 + 0];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            var r3 = getInt32Memory0()[retptr / 4 + 3];
            if (r3) {
                throw takeObject(r2);
            }
            return BigInt.asUintN(64, r0);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Converts a satoshi amount to BTC.
    * @param {bigint} sats
    * @returns {number}
    */
    static convert_sats_to_btc(sats) {
        const ret = wasm.mutinywallet_convert_sats_to_btc(sats);
        return ret;
    }
    /**
    * Convert an npub string to a hex string
    * @param {string} nsec
    * @returns {Promise<string>}
    */
    static nsec_to_npub(nsec) {
        const ptr0 = passStringToWasm0(nsec, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_nsec_to_npub(ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Convert an npub string to a hex string
    * @param {string} npub
    * @returns {Promise<string>}
    */
    static npub_to_hexpub(npub) {
        const ptr0 = passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_npub_to_hexpub(ptr0, len0);
        return takeObject(ret);
    }
    /**
    * Convert an hex string to a npub string
    * @param {string} npub
    * @returns {Promise<string>}
    */
    static hexpub_to_npub(npub) {
        const ptr0 = passStringToWasm0(npub, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_hexpub_to_npub(ptr0, len0);
        return takeObject(ret);
    }
    /**
    * If the invoice is from a node that gives hodl invoices
    * @param {string} invoice
    * @returns {Promise<boolean>}
    */
    static is_potential_hodl_invoice(invoice) {
        const ptr0 = passStringToWasm0(invoice, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.mutinywallet_is_potential_hodl_invoice(ptr0, len0);
        return takeObject(ret);
    }
}

const NodeIdentityFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_nodeidentity_free(ptr >>> 0));
/**
*/
export class NodeIdentity {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NodeIdentity.prototype);
        obj.__wbg_ptr = ptr;
        NodeIdentityFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NodeIdentityFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_nodeidentity_free(ptr);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.nodeidentity_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get uuid() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nodeidentity_uuid(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get pubkey() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nodeidentity_pubkey(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
}

const NwcProfileFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_nwcprofile_free(ptr >>> 0));
/**
*/
export class NwcProfile {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(NwcProfile.prototype);
        obj.__wbg_ptr = ptr;
        NwcProfileFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        NwcProfileFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_nwcprofile_free(ptr);
    }
    /**
    * @returns {number}
    */
    get index() {
        const ret = wasm.__wbg_get_nwcprofile_index(this.__wbg_ptr);
        return ret >>> 0;
    }
    /**
    * @param {number} arg0
    */
    set index(arg0) {
        wasm.__wbg_set_nwcprofile_index(this.__wbg_ptr, arg0);
    }
    /**
    * Maximum amount of sats that can be sent in a single payment
    * @returns {bigint}
    */
    get max_single_amt_sats() {
        const ret = wasm.__wbg_get_nwcprofile_max_single_amt_sats(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * Maximum amount of sats that can be sent in a single payment
    * @param {bigint} arg0
    */
    set max_single_amt_sats(arg0) {
        wasm.__wbg_set_nwcprofile_max_single_amt_sats(this.__wbg_ptr, arg0);
    }
    /**
    * Require approval before sending a payment
    * @returns {boolean}
    */
    get require_approval() {
        const ret = wasm.__wbg_get_nwcprofile_require_approval(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * Require approval before sending a payment
    * @param {boolean} arg0
    */
    set require_approval(arg0) {
        wasm.__wbg_set_nwcprofile_require_approval(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.nwcprofile_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get spending_conditions_type() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_spending_conditions_type(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_name(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get relay() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_relay(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get nwc_uri() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_nwc_uri(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get tag() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_tag(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get label() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_label(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint | undefined}
    */
    get budget_amount() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_budget_amount(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get budget_period() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_budget_period(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint | undefined}
    */
    get budget_remaining() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_budget_remaining(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {(string)[]}
    */
    get active_payments() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_active_payments(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
            wasm.__wbindgen_free(r0, r1 * 4, 4);
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get url_suffix() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.nwcprofile_url_suffix(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {boolean}
    */
    get enabled() {
        const ret = wasm.nwcprofile_enabled(this.__wbg_ptr);
        return ret !== 0;
    }
}

const PaymentParamsFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_paymentparams_free(ptr >>> 0));
/**
*/
export class PaymentParams {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PaymentParamsFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_paymentparams_free(ptr);
    }
    /**
    * @param {string} string
    */
    constructor(string) {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            const ptr0 = passStringToWasm0(string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
            const len0 = WASM_VECTOR_LEN;
            wasm.paymentparams_from_string(retptr, ptr0, len0);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            var r2 = getInt32Memory0()[retptr / 4 + 2];
            if (r2) {
                throw takeObject(r1);
            }
            this.__wbg_ptr = r0 >>> 0;
            return this;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get string() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_string(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get memo() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_memo(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get network() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_network(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @param {string} network
    * @returns {boolean | undefined}
    */
    valid_for_network(network) {
        const ptr0 = passStringToWasm0(network, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len0 = WASM_VECTOR_LEN;
        const ret = wasm.paymentparams_valid_for_network(this.__wbg_ptr, ptr0, len0);
        return ret === 0xFFFFFF ? undefined : ret !== 0;
    }
    /**
    * @returns {bigint | undefined}
    */
    get amount_sats() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_amount_sats(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {bigint | undefined}
    */
    get amount_msats() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_amount_msats(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r2 = getBigInt64Memory0()[retptr / 8 + 1];
            return r0 === 0 ? undefined : BigInt.asUintN(64, r2);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get address() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_address(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get invoice() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_invoice(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get offer() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_offer(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get refund() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_refund(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get node_pubkey() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_node_pubkey(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get lnurl() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_lnurl(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get lightning_address() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_lightning_address(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {boolean}
    */
    get is_lnurl_auth() {
        const ret = wasm.paymentparams_is_lnurl_auth(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * @returns {string | undefined}
    */
    get nostr_pubkey() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_nostr_pubkey(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get fedimint_invite_code() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_fedimint_invite_code(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get nostr_wallet_auth() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_nostr_wallet_auth(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get cashu_token() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_cashu_token(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get fedimint_oob_notes() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_fedimint_oob_notes(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get payjoin_endpoint() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.paymentparams_payjoin_endpoint(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {boolean | undefined}
    */
    get disable_output_substitution() {
        const ret = wasm.paymentparams_disable_output_substitution(this.__wbg_ptr);
        return ret === 0xFFFFFF ? undefined : ret !== 0;
    }
    /**
    * @returns {boolean}
    */
    get payjoin_supported() {
        const ret = wasm.paymentparams_payjoin_supported(this.__wbg_ptr);
        return ret !== 0;
    }
}

const PendingNwcInvoiceFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_pendingnwcinvoice_free(ptr >>> 0));
/**
* An invoice received over Nostr Wallet Connect that is pending approval or rejection
*/
export class PendingNwcInvoice {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(PendingNwcInvoice.prototype);
        obj.__wbg_ptr = ptr;
        PendingNwcInvoiceFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PendingNwcInvoiceFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_pendingnwcinvoice_free(ptr);
    }
    /**
    * Index of the profile that received the invoice.
    * None if invoice is from a DM
    * @returns {number | undefined}
    */
    get index() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.__wbg_get_pendingnwcinvoice_index(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            return r0 === 0 ? undefined : r1 >>> 0;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Index of the profile that received the invoice.
    * None if invoice is from a DM
    * @param {number | undefined} [arg0]
    */
    set index(arg0) {
        wasm.__wbg_set_pendingnwcinvoice_index(this.__wbg_ptr, !isLikeNone(arg0), isLikeNone(arg0) ? 0 : arg0);
    }
    /**
    * The amount of sats that the invoice is for
    * @returns {bigint}
    */
    get amount_sats() {
        const ret = wasm.__wbg_get_pendingnwcinvoice_amount_sats(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * The amount of sats that the invoice is for
    * @param {bigint} arg0
    */
    set amount_sats(arg0) {
        wasm.__wbg_set_pendingnwcinvoice_amount_sats(this.__wbg_ptr, arg0);
    }
    /**
    * Invoice expire time in seconds since epoch
    * @returns {bigint}
    */
    get expiry() {
        const ret = wasm.__wbg_get_pendingnwcinvoice_expiry(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * Invoice expire time in seconds since epoch
    * @param {bigint} arg0
    */
    set expiry(arg0) {
        wasm.__wbg_set_pendingnwcinvoice_expiry(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {string | undefined}
    */
    get npub() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pendingnwcinvoice_npub(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string}
    */
    get invoice() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pendingnwcinvoice_invoice(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pendingnwcinvoice_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get invoice_description() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pendingnwcinvoice_invoice_description(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * Name of the NWC Profile that received the invoice
    * @returns {string | undefined}
    */
    get profile_name() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.pendingnwcinvoice_profile_name(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

const PlanFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_plan_free(ptr >>> 0));
/**
*/
export class Plan {

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        PlanFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_plan_free(ptr);
    }
    /**
    * @returns {number}
    */
    get id() {
        const ret = wasm.__wbg_get_plan_id(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {number} arg0
    */
    set id(arg0) {
        wasm.__wbg_set_plan_id(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {bigint}
    */
    get amount_sat() {
        const ret = wasm.__wbg_get_plan_amount_sat(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * @param {bigint} arg0
    */
    set amount_sat(arg0) {
        wasm.__wbg_set_plan_amount_sat(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.plan_value(this.__wbg_ptr);
        return takeObject(ret);
    }
}

const TagItemFinalization = (typeof FinalizationRegistry === 'undefined')
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry(ptr => wasm.__wbg_tagitem_free(ptr >>> 0));
/**
*/
export class TagItem {

    static __wrap(ptr) {
        ptr = ptr >>> 0;
        const obj = Object.create(TagItem.prototype);
        obj.__wbg_ptr = ptr;
        TagItemFinalization.register(obj, obj.__wbg_ptr, obj);
        return obj;
    }

    __destroy_into_raw() {
        const ptr = this.__wbg_ptr;
        this.__wbg_ptr = 0;
        TagItemFinalization.unregister(this);
        return ptr;
    }

    free() {
        const ptr = this.__destroy_into_raw();
        wasm.__wbg_tagitem_free(ptr);
    }
    /**
    * @returns {TagKind}
    */
    get kind() {
        const ret = wasm.__wbg_get_tagitem_kind(this.__wbg_ptr);
        return ret;
    }
    /**
    * @param {TagKind} arg0
    */
    set kind(arg0) {
        wasm.__wbg_set_tagitem_kind(this.__wbg_ptr, arg0);
    }
    /**
    * Epoch time in seconds when this tag was last used
    * @returns {bigint}
    */
    get last_used_time() {
        const ret = wasm.__wbg_get_tagitem_last_used_time(this.__wbg_ptr);
        return BigInt.asUintN(64, ret);
    }
    /**
    * Epoch time in seconds when this tag was last used
    * @param {bigint} arg0
    */
    set last_used_time(arg0) {
        wasm.__wbg_set_tagitem_last_used_time(this.__wbg_ptr, arg0);
    }
    /**
    * If we follow this npub on nostr
    * @returns {boolean}
    */
    get is_followed() {
        const ret = wasm.__wbg_get_tagitem_is_followed(this.__wbg_ptr);
        return ret !== 0;
    }
    /**
    * If we follow this npub on nostr
    * @param {boolean} arg0
    */
    set is_followed(arg0) {
        wasm.__wbg_set_tagitem_is_followed(this.__wbg_ptr, arg0);
    }
    /**
    * @returns {any}
    */
    get value() {
        const ret = wasm.tagitem_value(this.__wbg_ptr);
        return takeObject(ret);
    }
    /**
    * @returns {string}
    */
    get id() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tagitem_id(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string}
    */
    get name() {
        let deferred1_0;
        let deferred1_1;
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tagitem_name(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            deferred1_0 = r0;
            deferred1_1 = r1;
            return getStringFromWasm0(r0, r1);
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
            wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get npub() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tagitem_npub(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get ln_address() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tagitem_ln_address(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get lnurl() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tagitem_lnurl(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get image_url() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tagitem_image_url(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
    /**
    * @returns {string | undefined}
    */
    get primal_image_url() {
        try {
            const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
            wasm.tagitem_primal_image_url(retptr, this.__wbg_ptr);
            var r0 = getInt32Memory0()[retptr / 4 + 0];
            var r1 = getInt32Memory0()[retptr / 4 + 1];
            let v1;
            if (r0 !== 0) {
                v1 = getStringFromWasm0(r0, r1).slice();
                wasm.__wbindgen_free(r0, r1 * 1, 1);
            }
            return v1;
        } finally {
            wasm.__wbindgen_add_to_stack_pointer(16);
        }
    }
}

async function __wbg_load(module, imports) {
    if (typeof Response === 'function' && module instanceof Response) {
        if (typeof WebAssembly.instantiateStreaming === 'function') {
            try {
                return await WebAssembly.instantiateStreaming(module, imports);

            } catch (e) {
                if (module.headers.get('Content-Type') != 'application/wasm') {
                    console.warn("`WebAssembly.instantiateStreaming` failed because your server does not serve wasm with `application/wasm` MIME type. Falling back to `WebAssembly.instantiate` which is slower. Original error:\n", e);

                } else {
                    throw e;
                }
            }
        }

        const bytes = await module.arrayBuffer();
        return await WebAssembly.instantiate(bytes, imports);

    } else {
        const instance = await WebAssembly.instantiate(module, imports);

        if (instance instanceof WebAssembly.Instance) {
            return { instance, module };

        } else {
            return instance;
        }
    }
}

function __wbg_get_imports() {
    const imports = {};
    imports.wbg = {};
    imports.wbg.__wbindgen_string_new = function(arg0, arg1) {
        const ret = getStringFromWasm0(arg0, arg1);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_number_new = function(arg0) {
        const ret = arg0;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_undefined = function(arg0) {
        const ret = getObject(arg0) === undefined;
        return ret;
    };
    imports.wbg.__wbindgen_is_null = function(arg0) {
        const ret = getObject(arg0) === null;
        return ret;
    };
    imports.wbg.__wbindgen_string_get = function(arg0, arg1) {
        const obj = getObject(arg1);
        const ret = typeof(obj) === 'string' ? obj : undefined;
        var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbindgen_object_drop_ref = function(arg0) {
        takeObject(arg0);
    };
    imports.wbg.__wbindgen_object_clone_ref = function(arg0) {
        const ret = getObject(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_function = function(arg0) {
        const ret = typeof(getObject(arg0)) === 'function';
        return ret;
    };
    imports.wbg.__wbg_mutinyinvoice_new = function(arg0) {
        const ret = MutinyInvoice.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_mutinychannel_new = function(arg0) {
        const ret = MutinyChannel.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_channelclosure_new = function(arg0) {
        const ret = ChannelClosure.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_mutinybalance_new = function(arg0) {
        const ret = MutinyBalance.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_federationbalance_new = function(arg0) {
        const ret = FederationBalance.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_federationbalances_new = function(arg0) {
        const ret = FederationBalances.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_lnurlparams_new = function(arg0) {
        const ret = LnUrlParams.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_nodeidentity_new = function(arg0) {
        const ret = NodeIdentity.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_federationidentity_new = function(arg0) {
        const ret = FederationIdentity.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_mutinybip21rawmaterials_new = function(arg0) {
        const ret = MutinyBip21RawMaterials.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_tagitem_new = function(arg0) {
        const ret = TagItem.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_nwcprofile_new = function(arg0) {
        const ret = NwcProfile.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_pendingnwcinvoice_new = function(arg0) {
        const ret = PendingNwcInvoice.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_fedimintsweepresult_new = function(arg0) {
        const ret = FedimintSweepResult.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_mutinywallet_new = function(arg0) {
        const ret = MutinyWallet.__wrap(arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_bigint_from_u64 = function(arg0) {
        const ret = BigInt.asUintN(64, arg0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_cb_drop = function(arg0) {
        const obj = takeObject(arg0).original;
        if (obj.cnt-- == 1) {
            obj.a = 0;
            return true;
        }
        const ret = false;
        return ret;
    };
    imports.wbg.__wbg_new_abda76e883ba8a5f = function() {
        const ret = new Error();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_stack_658279fe44541cf6 = function(arg0, arg1) {
        const ret = getObject(arg1).stack;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_error_f851667af71bcfc6 = function(arg0, arg1) {
        let deferred0_0;
        let deferred0_1;
        try {
            deferred0_0 = arg0;
            deferred0_1 = arg1;
            console.error(getStringFromWasm0(arg0, arg1));
        } finally {
            wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
        }
    };
    imports.wbg.__wbindgen_is_falsy = function(arg0) {
        const ret = !getObject(arg0);
        return ret;
    };
    imports.wbg.__wbindgen_is_string = function(arg0) {
        const ret = typeof(getObject(arg0)) === 'string';
        return ret;
    };
    imports.wbg.__wbg_performance_a1b8bde2ee512264 = function(arg0) {
        const ret = getObject(arg0).performance;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_now_abd80e969af37148 = function(arg0) {
        const ret = getObject(arg0).now();
        return ret;
    };
    imports.wbg.__wbg_clearTimeout_541ac0980ffcef74 = function(arg0) {
        const ret = clearTimeout(takeObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_setTimeout_7d81d052875b0f4f = function() { return handleError(function (arg0, arg1) {
        const ret = setTimeout(getObject(arg0), arg1);
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_clearTimeout_76877dbc010e786d = function(arg0) {
        const ret = clearTimeout(takeObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_setTimeout_75cb9b6991a4031d = function() { return handleError(function (arg0, arg1) {
        const ret = setTimeout(getObject(arg0), arg1);
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_fetch_bc7c8e27076a5c84 = function(arg0) {
        const ret = fetch(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_queueMicrotask_481971b0d87f3dd4 = function(arg0) {
        queueMicrotask(getObject(arg0));
    };
    imports.wbg.__wbg_queueMicrotask_3cbae2ec6b6cd3d6 = function(arg0) {
        const ret = getObject(arg0).queueMicrotask;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_instanceof_Window_99dc9805eaa2614b = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof Window;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_fetch_06d656a1b748ac0d = function(arg0, arg1) {
        const ret = getObject(arg0).fetch(getObject(arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_a979e9eedc5e81a3 = function() { return handleError(function () {
        const ret = new Headers();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_append_047382169b61373d = function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
        getObject(arg0).append(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
    }, arguments) };
    imports.wbg.__wbg_target_791826e938c3e308 = function(arg0) {
        const ret = getObject(arg0).target;
        return isLikeNone(ret) ? 0 : addHeapObject(ret);
    };
    imports.wbg.__wbg_new_3ff7ff424b10235d = function() { return handleError(function () {
        const ret = new FormData();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_append_ef03282181ca02ad = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        getObject(arg0).append(getStringFromWasm0(arg1, arg2), getObject(arg3));
    }, arguments) };
    imports.wbg.__wbg_append_7de46912be63ad86 = function() { return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5) {
        getObject(arg0).append(getStringFromWasm0(arg1, arg2), getObject(arg3), getStringFromWasm0(arg4, arg5));
    }, arguments) };
    imports.wbg.__wbg_append_6ee425c15561b5cc = function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
        getObject(arg0).append(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
    }, arguments) };
    imports.wbg.__wbg_instanceof_Blob_2c181202f4fb7894 = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof Blob;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_newwithu8arraysequenceandoptions_d0ee7f095b8bf8eb = function() { return handleError(function (arg0, arg1) {
        const ret = new Blob(getObject(arg0), getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_wasClean_ef83e1195bf30ede = function(arg0) {
        const ret = getObject(arg0).wasClean;
        return ret;
    };
    imports.wbg.__wbg_code_398d18e9145a1243 = function(arg0) {
        const ret = getObject(arg0).code;
        return ret;
    };
    imports.wbg.__wbg_reason_9f35a200bfe1c256 = function(arg0, arg1) {
        const ret = getObject(arg1).reason;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_newwitheventinitdict_ef6ede5e1c94c7d5 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = new CloseEvent(getStringFromWasm0(arg0, arg1), getObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_result_43945900200dc972 = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).result;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_error_ebceed2ec415ded1 = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).error;
        return isLikeNone(ret) ? 0 : addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_transaction_e0b73c5d10b37756 = function(arg0) {
        const ret = getObject(arg0).transaction;
        return isLikeNone(ret) ? 0 : addHeapObject(ret);
    };
    imports.wbg.__wbg_setonsuccess_8c53d1b7e13c41e5 = function(arg0, arg1) {
        getObject(arg0).onsuccess = getObject(arg1);
    };
    imports.wbg.__wbg_setonerror_39dab75ef2d606f0 = function(arg0, arg1) {
        getObject(arg0).onerror = getObject(arg1);
    };
    imports.wbg.__wbg_setoncomplete_9fc44a0f3233b408 = function(arg0, arg1) {
        getObject(arg0).oncomplete = getObject(arg1);
    };
    imports.wbg.__wbg_setonerror_6cfa9ee896eed159 = function(arg0, arg1) {
        getObject(arg0).onerror = getObject(arg1);
    };
    imports.wbg.__wbg_objectStore_fe6c5364a54fc56a = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = getObject(arg0).objectStore(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_data_5d6c23170bc379b2 = function(arg0) {
        const ret = getObject(arg0).data;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_url_2e2cb6de3f6c83d1 = function(arg0, arg1) {
        const ret = getObject(arg1).url;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_readyState_f57ac8451584c7a2 = function(arg0) {
        const ret = getObject(arg0).readyState;
        return ret;
    };
    imports.wbg.__wbg_setonopen_04738360055ee4a5 = function(arg0, arg1) {
        getObject(arg0).onopen = getObject(arg1);
    };
    imports.wbg.__wbg_setonerror_7434a4dce811f083 = function(arg0, arg1) {
        getObject(arg0).onerror = getObject(arg1);
    };
    imports.wbg.__wbg_setonclose_dabb00f27f00be8f = function(arg0, arg1) {
        getObject(arg0).onclose = getObject(arg1);
    };
    imports.wbg.__wbg_setonmessage_4acb1c5c244f296d = function(arg0, arg1) {
        getObject(arg0).onmessage = getObject(arg1);
    };
    imports.wbg.__wbg_setbinaryType_0d9ce182e4788f87 = function(arg0, arg1) {
        getObject(arg0).binaryType = takeObject(arg1);
    };
    imports.wbg.__wbg_new_bfaf72641458d8ec = function() { return handleError(function (arg0, arg1) {
        const ret = new WebSocket(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_close_fcf8af3a8d758756 = function() { return handleError(function (arg0) {
        getObject(arg0).close();
    }, arguments) };
    imports.wbg.__wbg_send_e35e2e3f8aa72e8f = function() { return handleError(function (arg0, arg1, arg2) {
        getObject(arg0).send(getStringFromWasm0(arg1, arg2));
    }, arguments) };
    imports.wbg.__wbg_send_069a6e5ee1ec8535 = function() { return handleError(function (arg0, arg1, arg2) {
        getObject(arg0).send(getArrayU8FromWasm0(arg1, arg2));
    }, arguments) };
    imports.wbg.__wbg_signal_7876560d9d0f914c = function(arg0) {
        const ret = getObject(arg0).signal;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_fa36281638875de8 = function() { return handleError(function () {
        const ret = new AbortController();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_abort_7792bf3f664d7bb3 = function(arg0) {
        getObject(arg0).abort();
    };
    imports.wbg.__wbg_instanceof_Response_0d25bb8436a9cefe = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof Response;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_url_47f8307501523859 = function(arg0, arg1) {
        const ret = getObject(arg1).url;
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_status_351700a30c61ba61 = function(arg0) {
        const ret = getObject(arg0).status;
        return ret;
    };
    imports.wbg.__wbg_headers_e38c00d713e8888c = function(arg0) {
        const ret = getObject(arg0).headers;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_arrayBuffer_ec4617b29bb0f61c = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).arrayBuffer();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_text_10c88c5e55f873c7 = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).text();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_code_31a474afa647a57e = function(arg0) {
        const ret = getObject(arg0).code;
        return ret;
    };
    imports.wbg.__wbg_objectStoreNames_39d5d8ff165673c0 = function(arg0) {
        const ret = getObject(arg0).objectStoreNames;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_close_acce9432a5e50b56 = function(arg0) {
        getObject(arg0).close();
    };
    imports.wbg.__wbg_createObjectStore_3e6033d951d4d4e3 = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        const ret = getObject(arg0).createObjectStore(getStringFromWasm0(arg1, arg2), getObject(arg3));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_deleteObjectStore_5e4d5099dfc2a4dd = function() { return handleError(function (arg0, arg1, arg2) {
        getObject(arg0).deleteObjectStore(getStringFromWasm0(arg1, arg2));
    }, arguments) };
    imports.wbg.__wbg_transaction_f3434456de85f902 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = getObject(arg0).transaction(getObject(arg1), takeObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_setonupgradeneeded_ebb6b49da07ef076 = function(arg0, arg1) {
        getObject(arg0).onupgradeneeded = getObject(arg1);
    };
    imports.wbg.__wbg_addEventListener_2f891d22985fd3c8 = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        getObject(arg0).addEventListener(getStringFromWasm0(arg1, arg2), getObject(arg3));
    }, arguments) };
    imports.wbg.__wbg_addEventListener_1b158e9e95e0ab00 = function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
        getObject(arg0).addEventListener(getStringFromWasm0(arg1, arg2), getObject(arg3), getObject(arg4));
    }, arguments) };
    imports.wbg.__wbg_dispatchEvent_5f789db90dec8217 = function() { return handleError(function (arg0, arg1) {
        const ret = getObject(arg0).dispatchEvent(getObject(arg1));
        return ret;
    }, arguments) };
    imports.wbg.__wbg_removeEventListener_07715e6f464823fc = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        getObject(arg0).removeEventListener(getStringFromWasm0(arg1, arg2), getObject(arg3));
    }, arguments) };
    imports.wbg.__wbg_indexNames_46f7cbd210ff2316 = function(arg0) {
        const ret = getObject(arg0).indexNames;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_clear_cb10866f326c2368 = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).clear();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_createIndex_224ae7381d3b4bfd = function() { return handleError(function (arg0, arg1, arg2, arg3, arg4) {
        const ret = getObject(arg0).createIndex(getStringFromWasm0(arg1, arg2), getObject(arg3), getObject(arg4));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_delete_a1548c00f44e1608 = function() { return handleError(function (arg0, arg1) {
        const ret = getObject(arg0).delete(getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_deleteIndex_c9c7ce8f15358d94 = function() { return handleError(function (arg0, arg1, arg2) {
        getObject(arg0).deleteIndex(getStringFromWasm0(arg1, arg2));
    }, arguments) };
    imports.wbg.__wbg_get_f477c47401497f39 = function() { return handleError(function (arg0, arg1) {
        const ret = getObject(arg0).get(getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_openCursor_f22aef1cc12ac4f8 = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).openCursor();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_openCursor_dfd216338fea9811 = function() { return handleError(function (arg0, arg1) {
        const ret = getObject(arg0).openCursor(getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_openCursor_d0e99645eacfd500 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = getObject(arg0).openCursor(getObject(arg1), takeObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_put_39d210624272c87d = function() { return handleError(function (arg0, arg1) {
        const ret = getObject(arg0).put(getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_put_d0c11cfda402797f = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = getObject(arg0).put(getObject(arg1), getObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_debug_81bf1b6b83cc1a06 = function(arg0) {
        console.debug(getObject(arg0));
    };
    imports.wbg.__wbg_error_1f4e3e298a7c97f6 = function(arg0) {
        console.error(getObject(arg0));
    };
    imports.wbg.__wbg_info_24b7c0f9d7eb6623 = function(arg0) {
        console.info(getObject(arg0));
    };
    imports.wbg.__wbg_log_9dfb3879776dd797 = function(arg0) {
        console.log(getObject(arg0));
    };
    imports.wbg.__wbg_warn_0e0204547af47087 = function(arg0) {
        console.warn(getObject(arg0));
    };
    imports.wbg.__wbg_instanceof_IdbFactory_44ad7bf9d2432630 = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof IDBFactory;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_open_67f43f98b0470c36 = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        const ret = getObject(arg0).open(getStringFromWasm0(arg1, arg2), arg3 >>> 0);
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_open_fdc86a2e78792175 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = getObject(arg0).open(getStringFromWasm0(arg1, arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_newwithstrandinit_9fd2fc855c6327eb = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = new Request(getStringFromWasm0(arg0, arg1), getObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_length_8df427eeded90205 = function(arg0) {
        const ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_contains_7a87af89c3705616 = function(arg0, arg1, arg2) {
        const ret = getObject(arg0).contains(getStringFromWasm0(arg1, arg2));
        return ret;
    };
    imports.wbg.__wbg_get_6de6fdeef4691e1a = function(arg0, arg1, arg2) {
        const ret = getObject(arg1)[arg2 >>> 0];
        var ptr1 = isLikeNone(ret) ? 0 : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        var len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbg_key_37c38754953d9548 = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).key;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_advance_91191c6e755be0cf = function() { return handleError(function (arg0, arg1) {
        getObject(arg0).advance(arg1 >>> 0);
    }, arguments) };
    imports.wbg.__wbg_continue_dc63786eb32e68f4 = function() { return handleError(function (arg0) {
        getObject(arg0).continue();
    }, arguments) };
    imports.wbg.__wbg_value_2423cc2503742f59 = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).value;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_crypto_d05b68a3572bb8ca = function(arg0) {
        const ret = getObject(arg0).crypto;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_is_object = function(arg0) {
        const val = getObject(arg0);
        const ret = typeof(val) === 'object' && val !== null;
        return ret;
    };
    imports.wbg.__wbg_process_b02b3570280d0366 = function(arg0) {
        const ret = getObject(arg0).process;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_versions_c1cb42213cedf0f5 = function(arg0) {
        const ret = getObject(arg0).versions;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_node_43b1089f407e4ec2 = function(arg0) {
        const ret = getObject(arg0).node;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_msCrypto_10fc94afee92bd76 = function(arg0) {
        const ret = getObject(arg0).msCrypto;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_require_9a7e0f667ead4995 = function() { return handleError(function () {
        const ret = module.require;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_randomFillSync_b70ccbdf4926a99d = function() { return handleError(function (arg0, arg1) {
        getObject(arg0).randomFillSync(takeObject(arg1));
    }, arguments) };
    imports.wbg.__wbg_getRandomValues_7e42b4fb8779dc6d = function() { return handleError(function (arg0, arg1) {
        getObject(arg0).getRandomValues(getObject(arg1));
    }, arguments) };
    imports.wbg.__wbg_new_16b304a2cfa7ff4a = function() {
        const ret = new Array();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newnoargs_e258087cd0daa0ea = function(arg0, arg1) {
        const ret = new Function(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_next_40fc327bfc8770e6 = function(arg0) {
        const ret = getObject(arg0).next;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_next_196c84450b364254 = function() { return handleError(function (arg0) {
        const ret = getObject(arg0).next();
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_done_298b57d23c0fc80c = function(arg0) {
        const ret = getObject(arg0).done;
        return ret;
    };
    imports.wbg.__wbg_value_d93c65011f51a456 = function(arg0) {
        const ret = getObject(arg0).value;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_iterator_2cee6dadfd956dfa = function() {
        const ret = Symbol.iterator;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_get_e3c254076557e348 = function() { return handleError(function (arg0, arg1) {
        const ret = Reflect.get(getObject(arg0), getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_call_27c0f87801dedf93 = function() { return handleError(function (arg0, arg1) {
        const ret = getObject(arg0).call(getObject(arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_new_72fb9a18b5ae2624 = function() {
        const ret = new Object();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_self_ce0dbfc45cf2f5be = function() { return handleError(function () {
        const ret = self.self;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_window_c6fb939a7f436783 = function() { return handleError(function () {
        const ret = window.window;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_globalThis_d1e6af4856ba331b = function() { return handleError(function () {
        const ret = globalThis.globalThis;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_global_207b558942527489 = function() { return handleError(function () {
        const ret = global.global;
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_push_a5b05aedc7234f9f = function(arg0, arg1) {
        const ret = getObject(arg0).push(getObject(arg1));
        return ret;
    };
    imports.wbg.__wbg_instanceof_ArrayBuffer_836825be07d4c9d2 = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof ArrayBuffer;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_instanceof_Error_e20bb56fd5591a93 = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof Error;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_new_28c511d9baebfa89 = function(arg0, arg1) {
        const ret = new Error(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_message_5bf28016c2b49cfb = function(arg0) {
        const ret = getObject(arg0).message;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_name_e7429f0dda6079e2 = function(arg0) {
        const ret = getObject(arg0).name;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_toString_ffe4c9ea3b3532e9 = function(arg0) {
        const ret = getObject(arg0).toString();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_call_b3ca7c6051f9bec1 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_call_8e7cb608789c2528 = function() { return handleError(function (arg0, arg1, arg2, arg3) {
        const ret = getObject(arg0).call(getObject(arg1), getObject(arg2), getObject(arg3));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_getTime_2bc4375165f02d15 = function(arg0) {
        const ret = getObject(arg0).getTime();
        return ret;
    };
    imports.wbg.__wbg_new0_7d84e5b2cd9fdc73 = function() {
        const ret = new Date();
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_now_3014639a94423537 = function() {
        const ret = Date.now();
        return ret;
    };
    imports.wbg.__wbg_instanceof_Object_71ca3c0a59266746 = function(arg0) {
        let result;
        try {
            result = getObject(arg0) instanceof Object;
        } catch (_) {
            result = false;
        }
        const ret = result;
        return ret;
    };
    imports.wbg.__wbg_new_81740750da40724f = function(arg0, arg1) {
        try {
            var state0 = {a: arg0, b: arg1};
            var cb0 = (arg0, arg1) => {
                const a = state0.a;
                state0.a = 0;
                try {
                    return __wbg_adapter_675(a, state0.b, arg0, arg1);
                } finally {
                    state0.a = a;
                }
            };
            const ret = new Promise(cb0);
            return addHeapObject(ret);
        } finally {
            state0.a = state0.b = 0;
        }
    };
    imports.wbg.__wbg_resolve_b0083a7967828ec8 = function(arg0) {
        const ret = Promise.resolve(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_then_0c86a60e8fcfe9f6 = function(arg0, arg1) {
        const ret = getObject(arg0).then(getObject(arg1));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_then_a73caa9a87991566 = function(arg0, arg1, arg2) {
        const ret = getObject(arg0).then(getObject(arg1), getObject(arg2));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_buffer_12d079cc21e14bdb = function(arg0) {
        const ret = getObject(arg0).buffer;
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_newwithbyteoffsetandlength_aa4a17c33a06e5cb = function(arg0, arg1, arg2) {
        const ret = new Uint8Array(getObject(arg0), arg1 >>> 0, arg2 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_new_63b92bc8671ed464 = function(arg0) {
        const ret = new Uint8Array(getObject(arg0));
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_set_a47bac70306a19a7 = function(arg0, arg1, arg2) {
        getObject(arg0).set(getObject(arg1), arg2 >>> 0);
    };
    imports.wbg.__wbg_length_c20a40f15020d68a = function(arg0) {
        const ret = getObject(arg0).length;
        return ret;
    };
    imports.wbg.__wbg_newwithlength_e9b4878cebadb3d3 = function(arg0) {
        const ret = new Uint8Array(arg0 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_subarray_a1f73cd4b5b42fe1 = function(arg0, arg1, arg2) {
        const ret = getObject(arg0).subarray(arg1 >>> 0, arg2 >>> 0);
        return addHeapObject(ret);
    };
    imports.wbg.__wbg_parse_66d1801634e099ac = function() { return handleError(function (arg0, arg1) {
        const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_stringify_8887fe74e1c50d81 = function() { return handleError(function (arg0) {
        const ret = JSON.stringify(getObject(arg0));
        return addHeapObject(ret);
    }, arguments) };
    imports.wbg.__wbg_has_0af94d20077affa2 = function() { return handleError(function (arg0, arg1) {
        const ret = Reflect.has(getObject(arg0), getObject(arg1));
        return ret;
    }, arguments) };
    imports.wbg.__wbg_set_1f9b04f170055d33 = function() { return handleError(function (arg0, arg1, arg2) {
        const ret = Reflect.set(getObject(arg0), getObject(arg1), getObject(arg2));
        return ret;
    }, arguments) };
    imports.wbg.__wbindgen_debug_string = function(arg0, arg1) {
        const ret = debugString(getObject(arg1));
        const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
        const len1 = WASM_VECTOR_LEN;
        getInt32Memory0()[arg0 / 4 + 1] = len1;
        getInt32Memory0()[arg0 / 4 + 0] = ptr1;
    };
    imports.wbg.__wbindgen_throw = function(arg0, arg1) {
        throw new Error(getStringFromWasm0(arg0, arg1));
    };
    imports.wbg.__wbindgen_memory = function() {
        const ret = wasm.memory;
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper17393 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 1359, __wbg_adapter_34);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper17395 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 1359, __wbg_adapter_37);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper21276 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 3099, __wbg_adapter_40);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper23844 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 3546, __wbg_adapter_43);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper23846 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 3546, __wbg_adapter_46);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper23848 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 3546, __wbg_adapter_43);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper23850 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 3546, __wbg_adapter_43);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper24287 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 3726, __wbg_adapter_53);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper24330 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 3743, __wbg_adapter_56);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper36107 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 9215, __wbg_adapter_59);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper37133 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 9496, __wbg_adapter_62);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper37135 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 9496, __wbg_adapter_65);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper37137 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 9496, __wbg_adapter_65);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper37139 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 9496, __wbg_adapter_65);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper37560 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 9646, __wbg_adapter_72);
        return addHeapObject(ret);
    };
    imports.wbg.__wbindgen_closure_wrapper38421 = function(arg0, arg1, arg2) {
        const ret = makeMutClosure(arg0, arg1, 10005, __wbg_adapter_75);
        return addHeapObject(ret);
    };

    return imports;
}

function __wbg_init_memory(imports, maybe_memory) {

}

function __wbg_finalize_init(instance, module) {
    wasm = instance.exports;
    __wbg_init.__wbindgen_wasm_module = module;
    cachedBigInt64Memory0 = null;
    cachedInt32Memory0 = null;
    cachedUint32Memory0 = null;
    cachedUint8Memory0 = null;

    wasm.__wbindgen_start();
    return wasm;
}

function initSync(module) {
    if (wasm !== undefined) return wasm;

    const imports = __wbg_get_imports();

    __wbg_init_memory(imports);

    if (!(module instanceof WebAssembly.Module)) {
        module = new WebAssembly.Module(module);
    }

    const instance = new WebAssembly.Instance(module, imports);

    return __wbg_finalize_init(instance, module);
}

async function __wbg_init(input) {
    if (wasm !== undefined) return wasm;

    if (typeof input === 'undefined') {
        input = new URL('mutiny_wasm_bg.wasm', import.meta.url);
    }
    const imports = __wbg_get_imports();

    if (typeof input === 'string' || (typeof Request === 'function' && input instanceof Request) || (typeof URL === 'function' && input instanceof URL)) {
        input = fetch(input);
    }

    __wbg_init_memory(imports);

    const { instance, module } = await __wbg_load(await input, imports);

    return __wbg_finalize_init(instance, module);
}

export { initSync }
export default __wbg_init;
